export const ADD_COLLABORATORS_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.AddCollaborators.AssetModificationNotPermitted';
export const ADD_COLLABORATORS_SUCCESS_COLLABORATORS_ADDED =
    'europa.space.AddCollaborators.CollaboratorsAdded';
export const ADD_COLLABORATORS_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.AddCollaborators.DerivedAssetMustNotBeModified';
export const ADD_COLLABORATORS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.AddCollaborators.EntityNotFoundOrNotAccessible';
export const ADD_COLLABORATORS_FAILURE_OWNER_MUST_NOT_BE_ADDED_AS_COLLABORATOR =
    'europa.space.AddCollaborators.OwnerMustNotBeAddedAsCollaborator';
export const ADD_COLLABORATORS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.AddCollaborators.UnexpectedFailure';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.BuildCompleteTransformationSql.AmbiguousColumnReference';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.BuildCompleteTransformationSql.CannotCastValueOfType';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.BuildCompleteTransformationSql.ClientConnectionError';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.BuildCompleteTransformationSql.CompilationFailedWithDatasetError';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_DATA_LOADING_FAILED =
    'europa.space.BuildCompleteTransformationSql.DataLoadingFailed';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.BuildCompleteTransformationSql.DatabaseNotExistsOrNotAuthorized';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.BuildCompleteTransformationSql.EntityNotFoundOrNotAccessible';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.BuildCompleteTransformationSql.InsufficientPrivileges';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.BuildCompleteTransformationSql.InsufficientTaskPrivileges';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.BuildCompleteTransformationSql.InvalidAccessToken';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.BuildCompleteTransformationSql.InvalidAccountName';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INVALID_IDENTIFIER =
    'europa.space.BuildCompleteTransformationSql.InvalidIdentifier';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.BuildCompleteTransformationSql.InvalidParameterTypeForFunction';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.BuildCompleteTransformationSql.MaxFileSizeExceeded';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_MISSING_COLUMN =
    'europa.space.BuildCompleteTransformationSql.MissingColumn';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.BuildCompleteTransformationSql.NoActiveWarehouseSelected';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.BuildCompleteTransformationSql.NotAuthenticatedToSnowflake';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.BuildCompleteTransformationSql.NotExistsOrNotAuthorized';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.BuildCompleteTransformationSql.NotExistsOrOperationCannotBePerformed';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.BuildCompleteTransformationSql.ObjectAlreadyExists';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.BuildCompleteTransformationSql.SchemaNotExistsOrNotAuthorized';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.BuildCompleteTransformationSql.SnowflakeInternalServerError';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.BuildCompleteTransformationSql.SnowflakeNotConfigured';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.BuildCompleteTransformationSql.SnowflakeQueryCanceled';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_TIMEOUT =
    'europa.space.BuildCompleteTransformationSql.Timeout';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_SUCCESS_TRANSFORMATION_SQL =
    'europa.space.BuildCompleteTransformationSql.TransformationSql';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.BuildCompleteTransformationSql.UncategorizedSqlError';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.BuildCompleteTransformationSql.UnexpectedFailure';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.BuildCompleteTransformationSql.UnknownFunction';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.BuildCompleteTransformationSql.UnknownFunctions';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.BuildCompleteTransformationSql.UserDiffersFromToken';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.BuildCompleteTransformationSql.ValueNotRecognized';
export const BUILD_COMPLETE_TRANSFORMATION_SQL_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.BuildCompleteTransformationSql.WarehouseSuspended';
export const COPY_SPACE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CopySpace.AssetModificationNotPermitted';
export const COPY_SPACE_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.CopySpace.DerivedAssetMustNotBeModified';
export const COPY_SPACE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CopySpace.EntityNotFoundOrNotAccessible';
export const COPY_SPACE_SUCCESS_SPACE_COPIED = 'europa.space.CopySpace.SpaceCopied';
export const COPY_SPACE_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CopySpace.UnexpectedFailure';
export const CREATE_AGGREGATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateAggregation.AmbiguousColumnReference';
export const CREATE_AGGREGATION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateAggregation.AssetModificationNotPermitted';
export const CREATE_AGGREGATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateAggregation.CannotCastValueOfType';
export const CREATE_AGGREGATION_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateAggregation.CircularReference';
export const CREATE_AGGREGATION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateAggregation.ClientConnectionError';
export const CREATE_AGGREGATION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateAggregation.CompilationFailedWithDatasetError';
export const CREATE_AGGREGATION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateAggregation.DataLoadingFailed';
export const CREATE_AGGREGATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateAggregation.DatabaseNotExistsOrNotAuthorized';
export const CREATE_AGGREGATION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateAggregation.DuplicateColumnNames';
export const CREATE_AGGREGATION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateAggregation.EntityNotFoundOrNotAccessible';
export const CREATE_AGGREGATION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateAggregation.InsufficientPrivileges';
export const CREATE_AGGREGATION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateAggregation.InsufficientTaskPrivileges';
export const CREATE_AGGREGATION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateAggregation.InvalidAccessToken';
export const CREATE_AGGREGATION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateAggregation.InvalidAccountName';
export const CREATE_AGGREGATION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateAggregation.InvalidIdentifier';
export const CREATE_AGGREGATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateAggregation.InvalidParameterTypeForFunction';
export const CREATE_AGGREGATION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateAggregation.MaxFileSizeExceeded';
export const CREATE_AGGREGATION_FAILURE_MISSING_COLUMN =
    'europa.space.CreateAggregation.MissingColumn';
export const CREATE_AGGREGATION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateAggregation.NoActiveWarehouseSelected';
export const CREATE_AGGREGATION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateAggregation.NotAuthenticatedToSnowflake';
export const CREATE_AGGREGATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateAggregation.NotExistsOrNotAuthorized';
export const CREATE_AGGREGATION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateAggregation.NotExistsOrOperationCannotBePerformed';
export const CREATE_AGGREGATION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateAggregation.ObjectAlreadyExists';
export const CREATE_AGGREGATION_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateAggregation.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_AGGREGATION_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateAggregation.OutputColumnsWithLineSeparator';
export const CREATE_AGGREGATION_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateAggregation.RequirementNotMet';
export const CREATE_AGGREGATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateAggregation.SchemaNotExistsOrNotAuthorized';
export const CREATE_AGGREGATION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateAggregation.SnowflakeInternalServerError';
export const CREATE_AGGREGATION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateAggregation.SnowflakeNotConfigured';
export const CREATE_AGGREGATION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateAggregation.SnowflakeQueryCanceled';
export const CREATE_AGGREGATION_FAILURE_TIMEOUT = 'europa.space.CreateAggregation.Timeout';
export const CREATE_AGGREGATION_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateAggregation.TransformationCreated';
export const CREATE_AGGREGATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateAggregation.UncategorizedSqlError';
export const CREATE_AGGREGATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateAggregation.UnexpectedFailure';
export const CREATE_AGGREGATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateAggregation.UnknownFunction';
export const CREATE_AGGREGATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateAggregation.UnknownFunctions';
export const CREATE_AGGREGATION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateAggregation.UserDiffersFromToken';
export const CREATE_AGGREGATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateAggregation.ValueNotRecognized';
export const CREATE_AGGREGATION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateAggregation.WarehouseSuspended';
export const CREATE_BLEND_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateBlend.AmbiguousColumnReference';
export const CREATE_BLEND_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateBlend.AssetModificationNotPermitted';
export const CREATE_BLEND_FAILURE_BLEND_CONDITIONS_EMPTY =
    'europa.space.CreateBlend.BlendConditionsEmpty';
export const CREATE_BLEND_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateBlend.CannotCastValueOfType';
export const CREATE_BLEND_FAILURE_CIRCULAR_REFERENCE = 'europa.space.CreateBlend.CircularReference';
export const CREATE_BLEND_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateBlend.ClientConnectionError';
export const CREATE_BLEND_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateBlend.CompilationFailedWithDatasetError';
export const CREATE_BLEND_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateBlend.DataLoadingFailed';
export const CREATE_BLEND_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateBlend.DatabaseNotExistsOrNotAuthorized';
export const CREATE_BLEND_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateBlend.DuplicateColumnNames';
export const CREATE_BLEND_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateBlend.EntityNotFoundOrNotAccessible';
export const CREATE_BLEND_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateBlend.InsufficientPrivileges';
export const CREATE_BLEND_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateBlend.InsufficientTaskPrivileges';
export const CREATE_BLEND_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateBlend.InvalidAccessToken';
export const CREATE_BLEND_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateBlend.InvalidAccountName';
export const CREATE_BLEND_FAILURE_INVALID_IDENTIFIER = 'europa.space.CreateBlend.InvalidIdentifier';
export const CREATE_BLEND_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateBlend.InvalidParameterTypeForFunction';
export const CREATE_BLEND_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateBlend.MaxFileSizeExceeded';
export const CREATE_BLEND_FAILURE_MISSING_COLUMN = 'europa.space.CreateBlend.MissingColumn';
export const CREATE_BLEND_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateBlend.NoActiveWarehouseSelected';
export const CREATE_BLEND_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateBlend.NotAuthenticatedToSnowflake';
export const CREATE_BLEND_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateBlend.NotExistsOrNotAuthorized';
export const CREATE_BLEND_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateBlend.NotExistsOrOperationCannotBePerformed';
export const CREATE_BLEND_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateBlend.ObjectAlreadyExists';
export const CREATE_BLEND_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateBlend.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_BLEND_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateBlend.OutputColumnsWithLineSeparator';
export const CREATE_BLEND_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateBlend.RequirementNotMet';
export const CREATE_BLEND_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateBlend.SchemaNotExistsOrNotAuthorized';
export const CREATE_BLEND_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateBlend.SnowflakeInternalServerError';
export const CREATE_BLEND_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateBlend.SnowflakeNotConfigured';
export const CREATE_BLEND_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateBlend.SnowflakeQueryCanceled';
export const CREATE_BLEND_FAILURE_TIMEOUT = 'europa.space.CreateBlend.Timeout';
export const CREATE_BLEND_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateBlend.TransformationCreated';
export const CREATE_BLEND_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateBlend.UncategorizedSqlError';
export const CREATE_BLEND_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreateBlend.UnexpectedFailure';
export const CREATE_BLEND_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateBlend.UnknownFunction';
export const CREATE_BLEND_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.CreateBlend.UnknownFunctions';
export const CREATE_BLEND_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateBlend.UserDiffersFromToken';
export const CREATE_BLEND_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateBlend.ValueNotRecognized';
export const CREATE_BLEND_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateBlend.WarehouseSuspended';
export const CREATE_FILTER_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateFilter.AmbiguousColumnReference';
export const CREATE_FILTER_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateFilter.AssetModificationNotPermitted';
export const CREATE_FILTER_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateFilter.CannotCastValueOfType';
export const CREATE_FILTER_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateFilter.CircularReference';
export const CREATE_FILTER_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateFilter.ClientConnectionError';
export const CREATE_FILTER_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateFilter.CompilationFailedWithDatasetError';
export const CREATE_FILTER_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateFilter.DataLoadingFailed';
export const CREATE_FILTER_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFilter.DatabaseNotExistsOrNotAuthorized';
export const CREATE_FILTER_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateFilter.DuplicateColumnNames';
export const CREATE_FILTER_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateFilter.EntityNotFoundOrNotAccessible';
export const CREATE_FILTER_FAILURE_FILTER_VALUE_HAS_INCOMPATIBLE_TYPE =
    'europa.space.CreateFilter.FilterValueHasIncompatibleType';
export const CREATE_FILTER_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateFilter.InsufficientPrivileges';
export const CREATE_FILTER_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateFilter.InsufficientTaskPrivileges';
export const CREATE_FILTER_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateFilter.InvalidAccessToken';
export const CREATE_FILTER_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateFilter.InvalidAccountName';
export const CREATE_FILTER_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateFilter.InvalidIdentifier';
export const CREATE_FILTER_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateFilter.InvalidParameterTypeForFunction';
export const CREATE_FILTER_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateFilter.MaxFileSizeExceeded';
export const CREATE_FILTER_FAILURE_MISSING_COLUMN = 'europa.space.CreateFilter.MissingColumn';
export const CREATE_FILTER_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateFilter.NoActiveWarehouseSelected';
export const CREATE_FILTER_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateFilter.NotAuthenticatedToSnowflake';
export const CREATE_FILTER_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFilter.NotExistsOrNotAuthorized';
export const CREATE_FILTER_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateFilter.NotExistsOrOperationCannotBePerformed';
export const CREATE_FILTER_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateFilter.ObjectAlreadyExists';
export const CREATE_FILTER_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateFilter.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_FILTER_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateFilter.OutputColumnsWithLineSeparator';
export const CREATE_FILTER_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateFilter.RequirementNotMet';
export const CREATE_FILTER_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFilter.SchemaNotExistsOrNotAuthorized';
export const CREATE_FILTER_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateFilter.SnowflakeInternalServerError';
export const CREATE_FILTER_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateFilter.SnowflakeNotConfigured';
export const CREATE_FILTER_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateFilter.SnowflakeQueryCanceled';
export const CREATE_FILTER_FAILURE_TIMEOUT = 'europa.space.CreateFilter.Timeout';
export const CREATE_FILTER_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateFilter.TransformationCreated';
export const CREATE_FILTER_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateFilter.UncategorizedSqlError';
export const CREATE_FILTER_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateFilter.UnexpectedFailure';
export const CREATE_FILTER_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateFilter.UnknownFunction';
export const CREATE_FILTER_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.CreateFilter.UnknownFunctions';
export const CREATE_FILTER_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateFilter.UserDiffersFromToken';
export const CREATE_FILTER_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateFilter.ValueNotRecognized';
export const CREATE_FILTER_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateFilter.WarehouseSuspended';
export const CREATE_FORMULA_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateFormula.AmbiguousColumnReference';
export const CREATE_FORMULA_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateFormula.AssetModificationNotPermitted';
export const CREATE_FORMULA_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateFormula.CannotCastValueOfType';
export const CREATE_FORMULA_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateFormula.CircularReference';
export const CREATE_FORMULA_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateFormula.ClientConnectionError';
export const CREATE_FORMULA_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateFormula.CompilationFailedWithDatasetError';
export const CREATE_FORMULA_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateFormula.DataLoadingFailed';
export const CREATE_FORMULA_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFormula.DatabaseNotExistsOrNotAuthorized';
export const CREATE_FORMULA_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateFormula.DuplicateColumnNames';
export const CREATE_FORMULA_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateFormula.EntityNotFoundOrNotAccessible';
export const CREATE_FORMULA_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateFormula.InsufficientPrivileges';
export const CREATE_FORMULA_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateFormula.InsufficientTaskPrivileges';
export const CREATE_FORMULA_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateFormula.InvalidAccessToken';
export const CREATE_FORMULA_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateFormula.InvalidAccountName';
export const CREATE_FORMULA_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateFormula.InvalidIdentifier';
export const CREATE_FORMULA_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateFormula.InvalidParameterTypeForFunction';
export const CREATE_FORMULA_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateFormula.MaxFileSizeExceeded';
export const CREATE_FORMULA_FAILURE_MISSING_COLUMN = 'europa.space.CreateFormula.MissingColumn';
export const CREATE_FORMULA_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateFormula.NoActiveWarehouseSelected';
export const CREATE_FORMULA_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateFormula.NotAuthenticatedToSnowflake';
export const CREATE_FORMULA_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFormula.NotExistsOrNotAuthorized';
export const CREATE_FORMULA_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateFormula.NotExistsOrOperationCannotBePerformed';
export const CREATE_FORMULA_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateFormula.ObjectAlreadyExists';
export const CREATE_FORMULA_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateFormula.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_FORMULA_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateFormula.OutputColumnsWithLineSeparator';
export const CREATE_FORMULA_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateFormula.RequirementNotMet';
export const CREATE_FORMULA_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateFormula.SchemaNotExistsOrNotAuthorized';
export const CREATE_FORMULA_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateFormula.SnowflakeInternalServerError';
export const CREATE_FORMULA_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateFormula.SnowflakeNotConfigured';
export const CREATE_FORMULA_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateFormula.SnowflakeQueryCanceled';
export const CREATE_FORMULA_FAILURE_TIMEOUT = 'europa.space.CreateFormula.Timeout';
export const CREATE_FORMULA_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateFormula.TransformationCreated';
export const CREATE_FORMULA_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateFormula.UncategorizedSqlError';
export const CREATE_FORMULA_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateFormula.UnexpectedFailure';
export const CREATE_FORMULA_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateFormula.UnknownFunction';
export const CREATE_FORMULA_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateFormula.UnknownFunctions';
export const CREATE_FORMULA_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateFormula.UserDiffersFromToken';
export const CREATE_FORMULA_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateFormula.ValueNotRecognized';
export const CREATE_FORMULA_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateFormula.WarehouseSuspended';
export const CREATE_GROUP_SUCCESS_GROUP_CREATED = 'europa.space.CreateGroup.GroupCreated';
export const CREATE_GROUP_FAILURE_NODE_ALREADY_IN_GROUP =
    'europa.space.CreateGroup.NodeAlreadyInGroup';
export const CREATE_GROUP_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreateGroup.UnexpectedFailure';
export const CREATE_PIVOT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreatePivot.AmbiguousColumnReference';
export const CREATE_PIVOT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreatePivot.AssetModificationNotPermitted';
export const CREATE_PIVOT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreatePivot.CannotCastValueOfType';
export const CREATE_PIVOT_FAILURE_CIRCULAR_REFERENCE = 'europa.space.CreatePivot.CircularReference';
export const CREATE_PIVOT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreatePivot.ClientConnectionError';
export const CREATE_PIVOT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreatePivot.CompilationFailedWithDatasetError';
export const CREATE_PIVOT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreatePivot.DataLoadingFailed';
export const CREATE_PIVOT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreatePivot.DatabaseNotExistsOrNotAuthorized';
export const CREATE_PIVOT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreatePivot.DuplicateColumnNames';
export const CREATE_PIVOT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreatePivot.EntityNotFoundOrNotAccessible';
export const CREATE_PIVOT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreatePivot.InsufficientPrivileges';
export const CREATE_PIVOT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreatePivot.InsufficientTaskPrivileges';
export const CREATE_PIVOT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreatePivot.InvalidAccessToken';
export const CREATE_PIVOT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreatePivot.InvalidAccountName';
export const CREATE_PIVOT_FAILURE_INVALID_IDENTIFIER = 'europa.space.CreatePivot.InvalidIdentifier';
export const CREATE_PIVOT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreatePivot.InvalidParameterTypeForFunction';
export const CREATE_PIVOT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreatePivot.MaxFileSizeExceeded';
export const CREATE_PIVOT_FAILURE_MISSING_COLUMN = 'europa.space.CreatePivot.MissingColumn';
export const CREATE_PIVOT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreatePivot.NoActiveWarehouseSelected';
export const CREATE_PIVOT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreatePivot.NotAuthenticatedToSnowflake';
export const CREATE_PIVOT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreatePivot.NotExistsOrNotAuthorized';
export const CREATE_PIVOT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreatePivot.NotExistsOrOperationCannotBePerformed';
export const CREATE_PIVOT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreatePivot.ObjectAlreadyExists';
export const CREATE_PIVOT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreatePivot.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_PIVOT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreatePivot.OutputColumnsWithLineSeparator';
export const CREATE_PIVOT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreatePivot.RequirementNotMet';
export const CREATE_PIVOT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreatePivot.SchemaNotExistsOrNotAuthorized';
export const CREATE_PIVOT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreatePivot.SnowflakeInternalServerError';
export const CREATE_PIVOT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreatePivot.SnowflakeNotConfigured';
export const CREATE_PIVOT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreatePivot.SnowflakeQueryCanceled';
export const CREATE_PIVOT_FAILURE_TIMEOUT = 'europa.space.CreatePivot.Timeout';
export const CREATE_PIVOT_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreatePivot.TransformationCreated';
export const CREATE_PIVOT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreatePivot.UncategorizedSqlError';
export const CREATE_PIVOT_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreatePivot.UnexpectedFailure';
export const CREATE_PIVOT_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreatePivot.UnknownFunction';
export const CREATE_PIVOT_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.CreatePivot.UnknownFunctions';
export const CREATE_PIVOT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreatePivot.UserDiffersFromToken';
export const CREATE_PIVOT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreatePivot.ValueNotRecognized';
export const CREATE_PIVOT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreatePivot.WarehouseSuspended';
export const CREATE_PROJECTION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateProjection.AmbiguousColumnReference';
export const CREATE_PROJECTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateProjection.AssetModificationNotPermitted';
export const CREATE_PROJECTION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateProjection.CannotCastValueOfType';
export const CREATE_PROJECTION_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateProjection.CircularReference';
export const CREATE_PROJECTION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateProjection.ClientConnectionError';
export const CREATE_PROJECTION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateProjection.CompilationFailedWithDatasetError';
export const CREATE_PROJECTION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateProjection.DataLoadingFailed';
export const CREATE_PROJECTION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateProjection.DatabaseNotExistsOrNotAuthorized';
export const CREATE_PROJECTION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateProjection.DuplicateColumnNames';
export const CREATE_PROJECTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateProjection.EntityNotFoundOrNotAccessible';
export const CREATE_PROJECTION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateProjection.InsufficientPrivileges';
export const CREATE_PROJECTION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateProjection.InsufficientTaskPrivileges';
export const CREATE_PROJECTION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateProjection.InvalidAccessToken';
export const CREATE_PROJECTION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateProjection.InvalidAccountName';
export const CREATE_PROJECTION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateProjection.InvalidIdentifier';
export const CREATE_PROJECTION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateProjection.InvalidParameterTypeForFunction';
export const CREATE_PROJECTION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateProjection.MaxFileSizeExceeded';
export const CREATE_PROJECTION_FAILURE_MISSING_COLUMN =
    'europa.space.CreateProjection.MissingColumn';
export const CREATE_PROJECTION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateProjection.NoActiveWarehouseSelected';
export const CREATE_PROJECTION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateProjection.NotAuthenticatedToSnowflake';
export const CREATE_PROJECTION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateProjection.NotExistsOrNotAuthorized';
export const CREATE_PROJECTION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateProjection.NotExistsOrOperationCannotBePerformed';
export const CREATE_PROJECTION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateProjection.ObjectAlreadyExists';
export const CREATE_PROJECTION_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateProjection.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_PROJECTION_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateProjection.OutputColumnsWithLineSeparator';
export const CREATE_PROJECTION_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateProjection.RequirementNotMet';
export const CREATE_PROJECTION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateProjection.SchemaNotExistsOrNotAuthorized';
export const CREATE_PROJECTION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateProjection.SnowflakeInternalServerError';
export const CREATE_PROJECTION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateProjection.SnowflakeNotConfigured';
export const CREATE_PROJECTION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateProjection.SnowflakeQueryCanceled';
export const CREATE_PROJECTION_FAILURE_TIMEOUT = 'europa.space.CreateProjection.Timeout';
export const CREATE_PROJECTION_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateProjection.TransformationCreated';
export const CREATE_PROJECTION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateProjection.UncategorizedSqlError';
export const CREATE_PROJECTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateProjection.UnexpectedFailure';
export const CREATE_PROJECTION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateProjection.UnknownFunction';
export const CREATE_PROJECTION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateProjection.UnknownFunctions';
export const CREATE_PROJECTION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateProjection.UserDiffersFromToken';
export const CREATE_PROJECTION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateProjection.ValueNotRecognized';
export const CREATE_PROJECTION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateProjection.WarehouseSuspended';
export const CREATE_REPLACE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateReplace.AmbiguousColumnReference';
export const CREATE_REPLACE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateReplace.AssetModificationNotPermitted';
export const CREATE_REPLACE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateReplace.CannotCastValueOfType';
export const CREATE_REPLACE_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateReplace.CircularReference';
export const CREATE_REPLACE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateReplace.ClientConnectionError';
export const CREATE_REPLACE_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateReplace.CompilationFailedWithDatasetError';
export const CREATE_REPLACE_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateReplace.DataLoadingFailed';
export const CREATE_REPLACE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateReplace.DatabaseNotExistsOrNotAuthorized';
export const CREATE_REPLACE_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateReplace.DuplicateColumnNames';
export const CREATE_REPLACE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateReplace.EntityNotFoundOrNotAccessible';
export const CREATE_REPLACE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateReplace.InsufficientPrivileges';
export const CREATE_REPLACE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateReplace.InsufficientTaskPrivileges';
export const CREATE_REPLACE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateReplace.InvalidAccessToken';
export const CREATE_REPLACE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateReplace.InvalidAccountName';
export const CREATE_REPLACE_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateReplace.InvalidIdentifier';
export const CREATE_REPLACE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateReplace.InvalidParameterTypeForFunction';
export const CREATE_REPLACE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateReplace.MaxFileSizeExceeded';
export const CREATE_REPLACE_FAILURE_MISSING_COLUMN = 'europa.space.CreateReplace.MissingColumn';
export const CREATE_REPLACE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateReplace.NoActiveWarehouseSelected';
export const CREATE_REPLACE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateReplace.NotAuthenticatedToSnowflake';
export const CREATE_REPLACE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateReplace.NotExistsOrNotAuthorized';
export const CREATE_REPLACE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateReplace.NotExistsOrOperationCannotBePerformed';
export const CREATE_REPLACE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateReplace.ObjectAlreadyExists';
export const CREATE_REPLACE_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateReplace.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_REPLACE_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateReplace.OutputColumnsWithLineSeparator';
export const CREATE_REPLACE_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateReplace.RequirementNotMet';
export const CREATE_REPLACE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateReplace.SchemaNotExistsOrNotAuthorized';
export const CREATE_REPLACE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateReplace.SnowflakeInternalServerError';
export const CREATE_REPLACE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateReplace.SnowflakeNotConfigured';
export const CREATE_REPLACE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateReplace.SnowflakeQueryCanceled';
export const CREATE_REPLACE_FAILURE_TIMEOUT = 'europa.space.CreateReplace.Timeout';
export const CREATE_REPLACE_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateReplace.TransformationCreated';
export const CREATE_REPLACE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateReplace.UncategorizedSqlError';
export const CREATE_REPLACE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateReplace.UnexpectedFailure';
export const CREATE_REPLACE_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateReplace.UnknownFunction';
export const CREATE_REPLACE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateReplace.UnknownFunctions';
export const CREATE_REPLACE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateReplace.UserDiffersFromToken';
export const CREATE_REPLACE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateReplace.ValueNotRecognized';
export const CREATE_REPLACE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateReplace.WarehouseSuspended';
export const CREATE_SPACE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateSpace.AssetModificationNotPermitted';
export const CREATE_SPACE_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.CreateSpace.DerivedAssetMustNotBeModified';
export const CREATE_SPACE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateSpace.EntityNotFoundOrNotAccessible';
export const CREATE_SPACE_SUCCESS_SPACE_CREATED = 'europa.space.CreateSpace.SpaceCreated';
export const CREATE_SPACE_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreateSpace.UnexpectedFailure';
export const CREATE_SPACE_WITH_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateSpaceWithView.AmbiguousColumnReference';
export const CREATE_SPACE_WITH_VIEW_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateSpaceWithView.AssetModificationNotPermitted';
export const CREATE_SPACE_WITH_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateSpaceWithView.CannotCastValueOfType';
export const CREATE_SPACE_WITH_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateSpaceWithView.ClientConnectionError';
export const CREATE_SPACE_WITH_VIEW_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateSpaceWithView.DataLoadingFailed';
export const CREATE_SPACE_WITH_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSpaceWithView.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SPACE_WITH_VIEW_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.CreateSpaceWithView.DerivedAssetMustNotBeModified';
export const CREATE_SPACE_WITH_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateSpaceWithView.EntityNotFoundOrNotAccessible';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateSpaceWithView.InsufficientPrivileges';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateSpaceWithView.InsufficientTaskPrivileges';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateSpaceWithView.InvalidAccessToken';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateSpaceWithView.InvalidAccountName';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateSpaceWithView.InvalidIdentifier';
export const CREATE_SPACE_WITH_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateSpaceWithView.InvalidParameterTypeForFunction';
export const CREATE_SPACE_WITH_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateSpaceWithView.MaxFileSizeExceeded';
export const CREATE_SPACE_WITH_VIEW_FAILURE_MISSING_COLUMN =
    'europa.space.CreateSpaceWithView.MissingColumn';
export const CREATE_SPACE_WITH_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateSpaceWithView.NoActiveWarehouseSelected';
export const CREATE_SPACE_WITH_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateSpaceWithView.NotAuthenticatedToSnowflake';
export const CREATE_SPACE_WITH_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSpaceWithView.NotExistsOrNotAuthorized';
export const CREATE_SPACE_WITH_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateSpaceWithView.NotExistsOrOperationCannotBePerformed';
export const CREATE_SPACE_WITH_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateSpaceWithView.ObjectAlreadyExists';
export const CREATE_SPACE_WITH_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSpaceWithView.SchemaNotExistsOrNotAuthorized';
export const CREATE_SPACE_WITH_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateSpaceWithView.SnowflakeInternalServerError';
export const CREATE_SPACE_WITH_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateSpaceWithView.SnowflakeNotConfigured';
export const CREATE_SPACE_WITH_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateSpaceWithView.SnowflakeQueryCanceled';
export const CREATE_SPACE_WITH_VIEW_SUCCESS_SPACE_CREATED_WITH_VIEW =
    'europa.space.CreateSpaceWithView.SpaceCreatedWithView';
export const CREATE_SPACE_WITH_VIEW_FAILURE_TIMEOUT = 'europa.space.CreateSpaceWithView.Timeout';
export const CREATE_SPACE_WITH_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateSpaceWithView.UncategorizedSqlError';
export const CREATE_SPACE_WITH_VIEW_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateSpaceWithView.UnexpectedFailure';
export const CREATE_SPACE_WITH_VIEW_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateSpaceWithView.UnknownFunction';
export const CREATE_SPACE_WITH_VIEW_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateSpaceWithView.UnknownFunctions';
export const CREATE_SPACE_WITH_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateSpaceWithView.UserDiffersFromToken';
export const CREATE_SPACE_WITH_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateSpaceWithView.ValueNotRecognized';
export const CREATE_SPACE_WITH_VIEW_FAILURE_VIEW_ALREADY_EXISTS =
    'europa.space.CreateSpaceWithView.ViewAlreadyExists';
export const CREATE_SPACE_WITH_VIEW_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateSpaceWithView.WarehouseSuspended';
export const CREATE_SPLIT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateSplit.AmbiguousColumnReference';
export const CREATE_SPLIT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateSplit.AssetModificationNotPermitted';
export const CREATE_SPLIT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateSplit.CannotCastValueOfType';
export const CREATE_SPLIT_FAILURE_CIRCULAR_REFERENCE = 'europa.space.CreateSplit.CircularReference';
export const CREATE_SPLIT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateSplit.ClientConnectionError';
export const CREATE_SPLIT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateSplit.CompilationFailedWithDatasetError';
export const CREATE_SPLIT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateSplit.DataLoadingFailed';
export const CREATE_SPLIT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSplit.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SPLIT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateSplit.DuplicateColumnNames';
export const CREATE_SPLIT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateSplit.EntityNotFoundOrNotAccessible';
export const CREATE_SPLIT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateSplit.InsufficientPrivileges';
export const CREATE_SPLIT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateSplit.InsufficientTaskPrivileges';
export const CREATE_SPLIT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateSplit.InvalidAccessToken';
export const CREATE_SPLIT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateSplit.InvalidAccountName';
export const CREATE_SPLIT_FAILURE_INVALID_IDENTIFIER = 'europa.space.CreateSplit.InvalidIdentifier';
export const CREATE_SPLIT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateSplit.InvalidParameterTypeForFunction';
export const CREATE_SPLIT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateSplit.MaxFileSizeExceeded';
export const CREATE_SPLIT_FAILURE_MISSING_COLUMN = 'europa.space.CreateSplit.MissingColumn';
export const CREATE_SPLIT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateSplit.NoActiveWarehouseSelected';
export const CREATE_SPLIT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateSplit.NotAuthenticatedToSnowflake';
export const CREATE_SPLIT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSplit.NotExistsOrNotAuthorized';
export const CREATE_SPLIT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateSplit.NotExistsOrOperationCannotBePerformed';
export const CREATE_SPLIT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateSplit.ObjectAlreadyExists';
export const CREATE_SPLIT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateSplit.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_SPLIT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateSplit.OutputColumnsWithLineSeparator';
export const CREATE_SPLIT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateSplit.RequirementNotMet';
export const CREATE_SPLIT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSplit.SchemaNotExistsOrNotAuthorized';
export const CREATE_SPLIT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateSplit.SnowflakeInternalServerError';
export const CREATE_SPLIT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateSplit.SnowflakeNotConfigured';
export const CREATE_SPLIT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateSplit.SnowflakeQueryCanceled';
export const CREATE_SPLIT_FAILURE_TIMEOUT = 'europa.space.CreateSplit.Timeout';
export const CREATE_SPLIT_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateSplit.TransformationCreated';
export const CREATE_SPLIT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateSplit.UncategorizedSqlError';
export const CREATE_SPLIT_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreateSplit.UnexpectedFailure';
export const CREATE_SPLIT_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateSplit.UnknownFunction';
export const CREATE_SPLIT_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.CreateSplit.UnknownFunctions';
export const CREATE_SPLIT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateSplit.UserDiffersFromToken';
export const CREATE_SPLIT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateSplit.ValueNotRecognized';
export const CREATE_SPLIT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateSplit.WarehouseSuspended';
export const CREATE_SQL_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateSqlView.AmbiguousColumnReference';
export const CREATE_SQL_VIEW_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateSqlView.AssetModificationNotPermitted';
export const CREATE_SQL_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateSqlView.CannotCastValueOfType';
export const CREATE_SQL_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateSqlView.ClientConnectionError';
export const CREATE_SQL_VIEW_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateSqlView.CompilationFailedWithDatasetError';
export const CREATE_SQL_VIEW_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateSqlView.DataLoadingFailed';
export const CREATE_SQL_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSqlView.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SQL_VIEW_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateSqlView.DuplicateColumnNames';
export const CREATE_SQL_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateSqlView.EntityNotFoundOrNotAccessible';
export const CREATE_SQL_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateSqlView.InsufficientPrivileges';
export const CREATE_SQL_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateSqlView.InsufficientTaskPrivileges';
export const CREATE_SQL_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateSqlView.InvalidAccessToken';
export const CREATE_SQL_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateSqlView.InvalidAccountName';
export const CREATE_SQL_VIEW_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateSqlView.InvalidIdentifier';
export const CREATE_SQL_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateSqlView.InvalidParameterTypeForFunction';
export const CREATE_SQL_VIEW_FAILURE_INVALID_SQL_SYNTAX =
    'europa.space.CreateSqlView.InvalidSqlSyntax';
export const CREATE_SQL_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateSqlView.MaxFileSizeExceeded';
export const CREATE_SQL_VIEW_FAILURE_MISSING_COLUMN = 'europa.space.CreateSqlView.MissingColumn';
export const CREATE_SQL_VIEW_FAILURE_MISSING_TABLE = 'europa.space.CreateSqlView.MissingTable';
export const CREATE_SQL_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateSqlView.NoActiveWarehouseSelected';
export const CREATE_SQL_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateSqlView.NotAuthenticatedToSnowflake';
export const CREATE_SQL_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSqlView.NotExistsOrNotAuthorized';
export const CREATE_SQL_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateSqlView.NotExistsOrOperationCannotBePerformed';
export const CREATE_SQL_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateSqlView.ObjectAlreadyExists';
export const CREATE_SQL_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateSqlView.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_SQL_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateSqlView.OutputColumnsWithLineSeparator';
export const CREATE_SQL_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSqlView.SchemaNotExistsOrNotAuthorized';
export const CREATE_SQL_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateSqlView.SnowflakeInternalServerError';
export const CREATE_SQL_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateSqlView.SnowflakeNotConfigured';
export const CREATE_SQL_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateSqlView.SnowflakeQueryCanceled';
export const CREATE_SQL_VIEW_SUCCESS_SQL_VIEW_CREATED = 'europa.space.CreateSqlView.SqlViewCreated';
export const CREATE_SQL_VIEW_FAILURE_TIMEOUT = 'europa.space.CreateSqlView.Timeout';
export const CREATE_SQL_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateSqlView.UncategorizedSqlError';
export const CREATE_SQL_VIEW_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateSqlView.UnexpectedFailure';
export const CREATE_SQL_VIEW_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateSqlView.UnknownFunction';
export const CREATE_SQL_VIEW_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateSqlView.UnknownFunctions';
export const CREATE_SQL_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateSqlView.UserDiffersFromToken';
export const CREATE_SQL_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateSqlView.ValueNotRecognized';
export const CREATE_SQL_VIEW_FAILURE_VIEW_ALREADY_EXISTS =
    'europa.space.CreateSqlView.ViewAlreadyExists';
export const CREATE_SQL_VIEW_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateSqlView.WarehouseSuspended';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateSubstringExtract.AmbiguousColumnReference';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateSubstringExtract.AssetModificationNotPermitted';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateSubstringExtract.CannotCastValueOfType';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.CreateSubstringExtract.CircularReference';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateSubstringExtract.ClientConnectionError';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateSubstringExtract.CompilationFailedWithDatasetError';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateSubstringExtract.DataLoadingFailed';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSubstringExtract.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateSubstringExtract.DuplicateColumnNames';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateSubstringExtract.EntityNotFoundOrNotAccessible';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateSubstringExtract.InsufficientPrivileges';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateSubstringExtract.InsufficientTaskPrivileges';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateSubstringExtract.InvalidAccessToken';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateSubstringExtract.InvalidAccountName';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateSubstringExtract.InvalidIdentifier';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateSubstringExtract.InvalidParameterTypeForFunction';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateSubstringExtract.MaxFileSizeExceeded';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_MISSING_COLUMN =
    'europa.space.CreateSubstringExtract.MissingColumn';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateSubstringExtract.NoActiveWarehouseSelected';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateSubstringExtract.NotAuthenticatedToSnowflake';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSubstringExtract.NotExistsOrNotAuthorized';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateSubstringExtract.NotExistsOrOperationCannotBePerformed';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateSubstringExtract.ObjectAlreadyExists';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateSubstringExtract.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateSubstringExtract.OutputColumnsWithLineSeparator';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.CreateSubstringExtract.RequirementNotMet';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateSubstringExtract.SchemaNotExistsOrNotAuthorized';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateSubstringExtract.SnowflakeInternalServerError';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateSubstringExtract.SnowflakeNotConfigured';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateSubstringExtract.SnowflakeQueryCanceled';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_TIMEOUT =
    'europa.space.CreateSubstringExtract.Timeout';
export const CREATE_SUBSTRING_EXTRACT_SUCCESS_TRANSFORMATION_CREATED =
    'europa.space.CreateSubstringExtract.TransformationCreated';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateSubstringExtract.UncategorizedSqlError';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateSubstringExtract.UnexpectedFailure';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateSubstringExtract.UnknownFunction';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateSubstringExtract.UnknownFunctions';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateSubstringExtract.UserDiffersFromToken';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateSubstringExtract.ValueNotRecognized';
export const CREATE_SUBSTRING_EXTRACT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateSubstringExtract.WarehouseSuspended';
export const CREATE_TRANSFORMATION_NODE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateTransformationNode.AmbiguousColumnReference';
export const CREATE_TRANSFORMATION_NODE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateTransformationNode.AssetModificationNotPermitted';
export const CREATE_TRANSFORMATION_NODE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateTransformationNode.CannotCastValueOfType';
export const CREATE_TRANSFORMATION_NODE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateTransformationNode.ClientConnectionError';
export const CREATE_TRANSFORMATION_NODE_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateTransformationNode.CompilationFailedWithDatasetError';
export const CREATE_TRANSFORMATION_NODE_FAILURE_COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS =
    'europa.space.CreateTransformationNode.CompilationFailedWithTransformationErrors';
export const CREATE_TRANSFORMATION_NODE_FAILURE_DATA_LOADING_FAILED =
    'europa.space.CreateTransformationNode.DataLoadingFailed';
export const CREATE_TRANSFORMATION_NODE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateTransformationNode.DatabaseNotExistsOrNotAuthorized';
export const CREATE_TRANSFORMATION_NODE_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateTransformationNode.DuplicateColumnNames';
export const CREATE_TRANSFORMATION_NODE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateTransformationNode.EntityNotFoundOrNotAccessible';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateTransformationNode.InsufficientPrivileges';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateTransformationNode.InsufficientTaskPrivileges';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateTransformationNode.InvalidAccessToken';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateTransformationNode.InvalidAccountName';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INVALID_IDENTIFIER =
    'europa.space.CreateTransformationNode.InvalidIdentifier';
export const CREATE_TRANSFORMATION_NODE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateTransformationNode.InvalidParameterTypeForFunction';
export const CREATE_TRANSFORMATION_NODE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateTransformationNode.MaxFileSizeExceeded';
export const CREATE_TRANSFORMATION_NODE_FAILURE_MISSING_COLUMN =
    'europa.space.CreateTransformationNode.MissingColumn';
export const CREATE_TRANSFORMATION_NODE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateTransformationNode.NoActiveWarehouseSelected';
export const CREATE_TRANSFORMATION_NODE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateTransformationNode.NotAuthenticatedToSnowflake';
export const CREATE_TRANSFORMATION_NODE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateTransformationNode.NotExistsOrNotAuthorized';
export const CREATE_TRANSFORMATION_NODE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateTransformationNode.NotExistsOrOperationCannotBePerformed';
export const CREATE_TRANSFORMATION_NODE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateTransformationNode.ObjectAlreadyExists';
export const CREATE_TRANSFORMATION_NODE_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateTransformationNode.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_TRANSFORMATION_NODE_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateTransformationNode.OutputColumnsWithLineSeparator';
export const CREATE_TRANSFORMATION_NODE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateTransformationNode.SchemaNotExistsOrNotAuthorized';
export const CREATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateTransformationNode.SnowflakeInternalServerError';
export const CREATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateTransformationNode.SnowflakeNotConfigured';
export const CREATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateTransformationNode.SnowflakeQueryCanceled';
export const CREATE_TRANSFORMATION_NODE_FAILURE_TIMEOUT =
    'europa.space.CreateTransformationNode.Timeout';
export const CREATE_TRANSFORMATION_NODE_SUCCESS_TRANSFORMATION_NODE_CREATED =
    'europa.space.CreateTransformationNode.TransformationNodeCreated';
export const CREATE_TRANSFORMATION_NODE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateTransformationNode.UncategorizedSqlError';
export const CREATE_TRANSFORMATION_NODE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.CreateTransformationNode.UnexpectedFailure';
export const CREATE_TRANSFORMATION_NODE_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.CreateTransformationNode.UnknownFunction';
export const CREATE_TRANSFORMATION_NODE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.CreateTransformationNode.UnknownFunctions';
export const CREATE_TRANSFORMATION_NODE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateTransformationNode.UserDiffersFromToken';
export const CREATE_TRANSFORMATION_NODE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateTransformationNode.ValueNotRecognized';
export const CREATE_TRANSFORMATION_NODE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.CreateTransformationNode.WarehouseSuspended';
export const CREATE_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.CreateView.AmbiguousColumnReference';
export const CREATE_VIEW_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.CreateView.AssetModificationNotPermitted';
export const CREATE_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.CreateView.CannotCastValueOfType';
export const CREATE_VIEW_FAILURE_CIRCULAR_REFERENCE = 'europa.space.CreateView.CircularReference';
export const CREATE_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.CreateView.ClientConnectionError';
export const CREATE_VIEW_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.CreateView.CompilationFailedWithDatasetError';
export const CREATE_VIEW_FAILURE_COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS =
    'europa.space.CreateView.CompilationFailedWithTransformationErrors';
export const CREATE_VIEW_FAILURE_DATA_LOADING_FAILED = 'europa.space.CreateView.DataLoadingFailed';
export const CREATE_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateView.DatabaseNotExistsOrNotAuthorized';
export const CREATE_VIEW_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.CreateView.DuplicateColumnNames';
export const CREATE_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.CreateView.EntityNotFoundOrNotAccessible';
export const CREATE_VIEW_FAILURE_FILTER_VALUE_HAS_INCOMPATIBLE_TYPE =
    'europa.space.CreateView.FilterValueHasIncompatibleType';
export const CREATE_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.CreateView.InsufficientPrivileges';
export const CREATE_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.CreateView.InsufficientTaskPrivileges';
export const CREATE_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.CreateView.InvalidAccessToken';
export const CREATE_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.CreateView.InvalidAccountName';
export const CREATE_VIEW_FAILURE_INVALID_IDENTIFIER = 'europa.space.CreateView.InvalidIdentifier';
export const CREATE_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.CreateView.InvalidParameterTypeForFunction';
export const CREATE_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.CreateView.MaxFileSizeExceeded';
export const CREATE_VIEW_FAILURE_MISSING_COLUMN = 'europa.space.CreateView.MissingColumn';
export const CREATE_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.CreateView.NoActiveWarehouseSelected';
export const CREATE_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.CreateView.NotAuthenticatedToSnowflake';
export const CREATE_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateView.NotExistsOrNotAuthorized';
export const CREATE_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.CreateView.NotExistsOrOperationCannotBePerformed';
export const CREATE_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.CreateView.ObjectAlreadyExists';
export const CREATE_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.CreateView.OutputColumnsWithInvisibleControlCharacters';
export const CREATE_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.CreateView.OutputColumnsWithLineSeparator';
export const CREATE_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.CreateView.SchemaNotExistsOrNotAuthorized';
export const CREATE_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.CreateView.SnowflakeInternalServerError';
export const CREATE_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.CreateView.SnowflakeNotConfigured';
export const CREATE_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.CreateView.SnowflakeQueryCanceled';
export const CREATE_VIEW_FAILURE_TIMEOUT = 'europa.space.CreateView.Timeout';
export const CREATE_VIEW_SUCCESS_TRANSFORMATION_STACK_CREATED =
    'europa.space.CreateView.TransformationStackCreated';
export const CREATE_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.CreateView.UncategorizedSqlError';
export const CREATE_VIEW_FAILURE_UNEXPECTED_FAILURE = 'europa.space.CreateView.UnexpectedFailure';
export const CREATE_VIEW_FAILURE_UNKNOWN_FUNCTION = 'europa.space.CreateView.UnknownFunction';
export const CREATE_VIEW_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.CreateView.UnknownFunctions';
export const CREATE_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.CreateView.UserDiffersFromToken';
export const CREATE_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.CreateView.ValueNotRecognized';
export const CREATE_VIEW_FAILURE_VIEW_ALREADY_EXISTS = 'europa.space.CreateView.ViewAlreadyExists';
export const CREATE_VIEW_FAILURE_WAREHOUSE_SUSPENDED = 'europa.space.CreateView.WarehouseSuspended';
export const DELETE_GROUP_SUCCESS_GROUP_DELETED = 'europa.space.DeleteGroup.GroupDeleted';
export const DELETE_GROUP_FAILURE_UNEXPECTED_FAILURE = 'europa.space.DeleteGroup.UnexpectedFailure';
export const DELETE_PROJECT_FAILURE_ASSET_DELETION_NOT_PERMITTED =
    'europa.space.DeleteProject.AssetDeletionNotPermitted';
export const DELETE_PROJECT_FAILURE_ASSET_NOT_DELETABLE =
    'europa.space.DeleteProject.AssetNotDeletable';
export const DELETE_PROJECT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.DeleteProject.EntityNotFoundOrNotAccessible';
export const DELETE_PROJECT_SUCCESS_PROJECT_DELETED = 'europa.space.DeleteProject.ProjectDeleted';
export const DELETE_PROJECT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.DeleteProject.UnexpectedFailure';
export const DELETE_TRANSFORMATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.DeleteTransformation.AmbiguousColumnReference';
export const DELETE_TRANSFORMATION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.DeleteTransformation.AssetModificationNotPermitted';
export const DELETE_TRANSFORMATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.DeleteTransformation.CannotCastValueOfType';
export const DELETE_TRANSFORMATION_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.DeleteTransformation.CircularReference';
export const DELETE_TRANSFORMATION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.DeleteTransformation.ClientConnectionError';
export const DELETE_TRANSFORMATION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.DeleteTransformation.CompilationFailedWithDatasetError';
export const DELETE_TRANSFORMATION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.DeleteTransformation.DataLoadingFailed';
export const DELETE_TRANSFORMATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.DeleteTransformation.DatabaseNotExistsOrNotAuthorized';
export const DELETE_TRANSFORMATION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.DeleteTransformation.DuplicateColumnNames';
export const DELETE_TRANSFORMATION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.DeleteTransformation.EntityNotFoundOrNotAccessible';
export const DELETE_TRANSFORMATION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.DeleteTransformation.InsufficientPrivileges';
export const DELETE_TRANSFORMATION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.DeleteTransformation.InsufficientTaskPrivileges';
export const DELETE_TRANSFORMATION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.DeleteTransformation.InvalidAccessToken';
export const DELETE_TRANSFORMATION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.DeleteTransformation.InvalidAccountName';
export const DELETE_TRANSFORMATION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.DeleteTransformation.InvalidIdentifier';
export const DELETE_TRANSFORMATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.DeleteTransformation.InvalidParameterTypeForFunction';
export const DELETE_TRANSFORMATION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.DeleteTransformation.MaxFileSizeExceeded';
export const DELETE_TRANSFORMATION_FAILURE_MISSING_COLUMN =
    'europa.space.DeleteTransformation.MissingColumn';
export const DELETE_TRANSFORMATION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.DeleteTransformation.NoActiveWarehouseSelected';
export const DELETE_TRANSFORMATION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.DeleteTransformation.NotAuthenticatedToSnowflake';
export const DELETE_TRANSFORMATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.DeleteTransformation.NotExistsOrNotAuthorized';
export const DELETE_TRANSFORMATION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.DeleteTransformation.NotExistsOrOperationCannotBePerformed';
export const DELETE_TRANSFORMATION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.DeleteTransformation.ObjectAlreadyExists';
export const DELETE_TRANSFORMATION_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.DeleteTransformation.OutputColumnsWithInvisibleControlCharacters';
export const DELETE_TRANSFORMATION_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.DeleteTransformation.OutputColumnsWithLineSeparator';
export const DELETE_TRANSFORMATION_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.DeleteTransformation.RequirementNotMet';
export const DELETE_TRANSFORMATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.DeleteTransformation.SchemaNotExistsOrNotAuthorized';
export const DELETE_TRANSFORMATION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.DeleteTransformation.SnowflakeInternalServerError';
export const DELETE_TRANSFORMATION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.DeleteTransformation.SnowflakeNotConfigured';
export const DELETE_TRANSFORMATION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.DeleteTransformation.SnowflakeQueryCanceled';
export const DELETE_TRANSFORMATION_FAILURE_TIMEOUT = 'europa.space.DeleteTransformation.Timeout';
export const DELETE_TRANSFORMATION_SUCCESS_TRANSFORMATION_DELETED =
    'europa.space.DeleteTransformation.TransformationDeleted';
export const DELETE_TRANSFORMATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.DeleteTransformation.UncategorizedSqlError';
export const DELETE_TRANSFORMATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.DeleteTransformation.UnexpectedFailure';
export const DELETE_TRANSFORMATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.DeleteTransformation.UnknownFunction';
export const DELETE_TRANSFORMATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.DeleteTransformation.UnknownFunctions';
export const DELETE_TRANSFORMATION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.DeleteTransformation.UserDiffersFromToken';
export const DELETE_TRANSFORMATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.DeleteTransformation.ValueNotRecognized';
export const DELETE_TRANSFORMATION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.DeleteTransformation.WarehouseSuspended';
export const DELETE_UNUSED_DATASETS_FROM_PROJECT_SUCCESS_DELETE_UNUSED_DATASETS_FROM_PROJECT_REQUESTED =
    'europa.space.DeleteUnusedDatasetsFromProject.DeleteUnusedDatasetsFromProjectRequested';
export const DELETE_UNUSED_DATASETS_FROM_PROJECT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.DeleteUnusedDatasetsFromProject.UnexpectedFailure';
export const DELETE_VIEW_FAILURE_ASSET_DELETION_NOT_PERMITTED =
    'europa.space.DeleteView.AssetDeletionNotPermitted';
export const DELETE_VIEW_FAILURE_ASSET_NOT_DELETABLE = 'europa.space.DeleteView.AssetNotDeletable';
export const DELETE_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.DeleteView.EntityNotFoundOrNotAccessible';
export const DELETE_VIEW_FAILURE_UNEXPECTED_FAILURE = 'europa.space.DeleteView.UnexpectedFailure';
export const DELETE_VIEW_SUCCESS_VIEW_DELETED = 'europa.space.DeleteView.ViewDeleted';
export const EXCHANGE_SOURCE_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ExchangeSourceView.AmbiguousColumnReference';
export const EXCHANGE_SOURCE_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ExchangeSourceView.CannotCastValueOfType';
export const EXCHANGE_SOURCE_VIEW_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.ExchangeSourceView.CircularReference';
export const EXCHANGE_SOURCE_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.ExchangeSourceView.ClientConnectionError';
export const EXCHANGE_SOURCE_VIEW_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.ExchangeSourceView.CompilationFailedWithDatasetError';
export const EXCHANGE_SOURCE_VIEW_FAILURE_DATA_LOADING_FAILED =
    'europa.space.ExchangeSourceView.DataLoadingFailed';
export const EXCHANGE_SOURCE_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ExchangeSourceView.DatabaseNotExistsOrNotAuthorized';
export const EXCHANGE_SOURCE_VIEW_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.ExchangeSourceView.DuplicateColumnNames';
export const EXCHANGE_SOURCE_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ExchangeSourceView.EntityNotFoundOrNotAccessible';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.ExchangeSourceView.InsufficientPrivileges';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.ExchangeSourceView.InsufficientTaskPrivileges';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.ExchangeSourceView.InvalidAccessToken';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.ExchangeSourceView.InvalidAccountName';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INVALID_IDENTIFIER =
    'europa.space.ExchangeSourceView.InvalidIdentifier';
export const EXCHANGE_SOURCE_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ExchangeSourceView.InvalidParameterTypeForFunction';
export const EXCHANGE_SOURCE_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.ExchangeSourceView.MaxFileSizeExceeded';
export const EXCHANGE_SOURCE_VIEW_FAILURE_MISSING_COLUMN =
    'europa.space.ExchangeSourceView.MissingColumn';
export const EXCHANGE_SOURCE_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.ExchangeSourceView.NoActiveWarehouseSelected';
export const EXCHANGE_SOURCE_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.ExchangeSourceView.NotAuthenticatedToSnowflake';
export const EXCHANGE_SOURCE_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ExchangeSourceView.NotExistsOrNotAuthorized';
export const EXCHANGE_SOURCE_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.ExchangeSourceView.NotExistsOrOperationCannotBePerformed';
export const EXCHANGE_SOURCE_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.ExchangeSourceView.ObjectAlreadyExists';
export const EXCHANGE_SOURCE_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.ExchangeSourceView.OutputColumnsWithInvisibleControlCharacters';
export const EXCHANGE_SOURCE_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.ExchangeSourceView.OutputColumnsWithLineSeparator';
export const EXCHANGE_SOURCE_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ExchangeSourceView.SchemaNotExistsOrNotAuthorized';
export const EXCHANGE_SOURCE_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.ExchangeSourceView.SnowflakeInternalServerError';
export const EXCHANGE_SOURCE_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.ExchangeSourceView.SnowflakeNotConfigured';
export const EXCHANGE_SOURCE_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.ExchangeSourceView.SnowflakeQueryCanceled';
export const EXCHANGE_SOURCE_VIEW_SUCCESS_SOURCE_VIEW_EXCHANGED =
    'europa.space.ExchangeSourceView.SourceViewExchanged';
export const EXCHANGE_SOURCE_VIEW_FAILURE_SOURCE_VIEW_NOT_EXCHANGEABLE =
    'europa.space.ExchangeSourceView.SourceViewNotExchangeable';
export const EXCHANGE_SOURCE_VIEW_FAILURE_TIMEOUT = 'europa.space.ExchangeSourceView.Timeout';
export const EXCHANGE_SOURCE_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ExchangeSourceView.UncategorizedSqlError';
export const EXCHANGE_SOURCE_VIEW_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ExchangeSourceView.UnexpectedFailure';
export const EXCHANGE_SOURCE_VIEW_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.ExchangeSourceView.UnknownFunction';
export const EXCHANGE_SOURCE_VIEW_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.ExchangeSourceView.UnknownFunctions';
export const EXCHANGE_SOURCE_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.ExchangeSourceView.UserDiffersFromToken';
export const EXCHANGE_SOURCE_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ExchangeSourceView.ValueNotRecognized';
export const EXCHANGE_SOURCE_VIEW_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.ExchangeSourceView.WarehouseSuspended';
export const FIND_SPACES_SUCCESS_SPACES_FOUND = 'europa.space.FindSpaces.SpacesFound';
export const FIND_SPACES_FAILURE_UNEXPECTED_FAILURE = 'europa.space.FindSpaces.UnexpectedFailure';
export const GET_EXECUTION_HISTORY_SUCCESS_EXECUTION_HISTORY =
    'europa.space.GetExecutionHistory.ExecutionHistory';
export const GET_EXECUTION_HISTORY_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetExecutionHistory.UnexpectedFailure';
export const GET_OUTPUT_COLUMNS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetOutputColumns.EntityNotFoundOrNotAccessible';
export const GET_OUTPUT_COLUMNS_SUCCESS_OUTPUT_COLUMNS =
    'europa.space.GetOutputColumns.OutputColumns';
export const GET_OUTPUT_COLUMNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetOutputColumns.UnexpectedFailure';
export const GET_PROJECT_DEPENDENCIES_SUCCESS_PROJECT_DEPENDENCIES =
    'europa.space.GetProjectDependencies.ProjectDependencies';
export const GET_PROJECT_DEPENDENCIES_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetProjectDependencies.UnexpectedFailure';
export const GET_PROJECT_INPUTS_SUCCESS_PROJECT_INPUTS =
    'europa.space.GetProjectInputs.ProjectInputs';
export const GET_PROJECT_INPUTS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetProjectInputs.UnexpectedFailure';
export const GET_PROJECT_REFERENCES_SUCCESS_PROJECT_REFERENCES =
    'europa.space.GetProjectReferences.ProjectReferences';
export const GET_PROJECT_REFERENCES_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetProjectReferences.UnexpectedFailure';
export const GET_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS_SUCCESS_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS =
    'europa.space.GetProjectsContainingTableDeployments.ProjectsContainingTableDeployments';
export const GET_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetProjectsContainingTableDeployments.UnexpectedFailure';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.GetSnowflakeSqlByProjectSql.AmbiguousColumnReference';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.GetSnowflakeSqlByProjectSql.CannotCastValueOfType';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.GetSnowflakeSqlByProjectSql.ClientConnectionError';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.GetSnowflakeSqlByProjectSql.CompilationFailedWithDatasetError';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_DATA_LOADING_FAILED =
    'europa.space.GetSnowflakeSqlByProjectSql.DataLoadingFailed';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByProjectSql.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeSqlByProjectSql.EntityNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByProjectSql.InsufficientPrivileges';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByProjectSql.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.GetSnowflakeSqlByProjectSql.InvalidAccessToken';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.GetSnowflakeSqlByProjectSql.InvalidAccountName';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INVALID_IDENTIFIER =
    'europa.space.GetSnowflakeSqlByProjectSql.InvalidIdentifier';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.GetSnowflakeSqlByProjectSql.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_INVALID_SQL_SYNTAX =
    'europa.space.GetSnowflakeSqlByProjectSql.InvalidSqlSyntax';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.GetSnowflakeSqlByProjectSql.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_MISSING_COLUMN =
    'europa.space.GetSnowflakeSqlByProjectSql.MissingColumn';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_MISSING_TABLE =
    'europa.space.GetSnowflakeSqlByProjectSql.MissingTable';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.GetSnowflakeSqlByProjectSql.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.GetSnowflakeSqlByProjectSql.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByProjectSql.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.GetSnowflakeSqlByProjectSql.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.GetSnowflakeSqlByProjectSql.ObjectAlreadyExists';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByProjectSql.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.GetSnowflakeSqlByProjectSql.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.GetSnowflakeSqlByProjectSql.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.GetSnowflakeSqlByProjectSql.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_SUCCESS_SNOWFLAKE_SQL =
    'europa.space.GetSnowflakeSqlByProjectSql.SnowflakeSql';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_TIMEOUT =
    'europa.space.GetSnowflakeSqlByProjectSql.Timeout';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.GetSnowflakeSqlByProjectSql.UncategorizedSqlError';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSnowflakeSqlByProjectSql.UnexpectedFailure';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.GetSnowflakeSqlByProjectSql.UnknownFunction';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.GetSnowflakeSqlByProjectSql.UnknownFunctions';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.GetSnowflakeSqlByProjectSql.UserDiffersFromToken';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.GetSnowflakeSqlByProjectSql.ValueNotRecognized';
export const GET_SNOWFLAKE_SQL_BY_PROJECT_SQL_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.GetSnowflakeSqlByProjectSql.WarehouseSuspended';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.GetSnowflakeSqlByTransformation.AmbiguousColumnReference';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.GetSnowflakeSqlByTransformation.CannotCastValueOfType';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.GetSnowflakeSqlByTransformation.ClientConnectionError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.GetSnowflakeSqlByTransformation.CompilationFailedWithDatasetError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.GetSnowflakeSqlByTransformation.DataLoadingFailed';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformation.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeSqlByTransformation.EntityNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByTransformation.InsufficientPrivileges';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByTransformation.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.GetSnowflakeSqlByTransformation.InvalidAccessToken';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.GetSnowflakeSqlByTransformation.InvalidAccountName';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.GetSnowflakeSqlByTransformation.InvalidIdentifier';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.GetSnowflakeSqlByTransformation.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.GetSnowflakeSqlByTransformation.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_MISSING_COLUMN =
    'europa.space.GetSnowflakeSqlByTransformation.MissingColumn';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.GetSnowflakeSqlByTransformation.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.GetSnowflakeSqlByTransformation.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformation.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.GetSnowflakeSqlByTransformation.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.GetSnowflakeSqlByTransformation.ObjectAlreadyExists';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformation.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.GetSnowflakeSqlByTransformation.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.GetSnowflakeSqlByTransformation.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.GetSnowflakeSqlByTransformation.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_SUCCESS_SNOWFLAKE_SQL =
    'europa.space.GetSnowflakeSqlByTransformation.SnowflakeSql';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_TIMEOUT =
    'europa.space.GetSnowflakeSqlByTransformation.Timeout';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.GetSnowflakeSqlByTransformation.UncategorizedSqlError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSnowflakeSqlByTransformation.UnexpectedFailure';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.GetSnowflakeSqlByTransformation.UnknownFunction';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.GetSnowflakeSqlByTransformation.UnknownFunctions';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.GetSnowflakeSqlByTransformation.UserDiffersFromToken';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.GetSnowflakeSqlByTransformation.ValueNotRecognized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.GetSnowflakeSqlByTransformation.WarehouseSuspended';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.GetSnowflakeSqlByTransformationId.AmbiguousColumnReference';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.GetSnowflakeSqlByTransformationId.CannotCastValueOfType';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.GetSnowflakeSqlByTransformationId.ClientConnectionError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.GetSnowflakeSqlByTransformationId.CompilationFailedWithDatasetError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_DATA_LOADING_FAILED =
    'europa.space.GetSnowflakeSqlByTransformationId.DataLoadingFailed';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformationId.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeSqlByTransformationId.EntityNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByTransformationId.InsufficientPrivileges';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.GetSnowflakeSqlByTransformationId.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.GetSnowflakeSqlByTransformationId.InvalidAccessToken';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.GetSnowflakeSqlByTransformationId.InvalidAccountName';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INVALID_IDENTIFIER =
    'europa.space.GetSnowflakeSqlByTransformationId.InvalidIdentifier';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.GetSnowflakeSqlByTransformationId.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.GetSnowflakeSqlByTransformationId.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_MISSING_COLUMN =
    'europa.space.GetSnowflakeSqlByTransformationId.MissingColumn';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.GetSnowflakeSqlByTransformationId.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.GetSnowflakeSqlByTransformationId.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformationId.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.GetSnowflakeSqlByTransformationId.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.GetSnowflakeSqlByTransformationId.ObjectAlreadyExists';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlByTransformationId.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.GetSnowflakeSqlByTransformationId.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.GetSnowflakeSqlByTransformationId.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.GetSnowflakeSqlByTransformationId.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_SUCCESS_SNOWFLAKE_SQL =
    'europa.space.GetSnowflakeSqlByTransformationId.SnowflakeSql';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_TIMEOUT =
    'europa.space.GetSnowflakeSqlByTransformationId.Timeout';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.GetSnowflakeSqlByTransformationId.UncategorizedSqlError';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSnowflakeSqlByTransformationId.UnexpectedFailure';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.GetSnowflakeSqlByTransformationId.UnknownFunction';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.GetSnowflakeSqlByTransformationId.UnknownFunctions';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.GetSnowflakeSqlByTransformationId.UserDiffersFromToken';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.GetSnowflakeSqlByTransformationId.ValueNotRecognized';
export const GET_SNOWFLAKE_SQL_BY_TRANSFORMATION_ID_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.GetSnowflakeSqlByTransformationId.WarehouseSuspended';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.GetSnowflakeSqlForOutputMapping.AmbiguousColumnReference';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.GetSnowflakeSqlForOutputMapping.CannotCastValueOfType';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.GetSnowflakeSqlForOutputMapping.ClientConnectionError';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.GetSnowflakeSqlForOutputMapping.CompilationFailedWithDatasetError';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_DATA_LOADING_FAILED =
    'europa.space.GetSnowflakeSqlForOutputMapping.DataLoadingFailed';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_SUCCESS_DATA_SAMPLE_SQL =
    'europa.space.GetSnowflakeSqlForOutputMapping.DataSampleSql';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlForOutputMapping.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeSqlForOutputMapping.EntityNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.GetSnowflakeSqlForOutputMapping.InsufficientPrivileges';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.GetSnowflakeSqlForOutputMapping.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.GetSnowflakeSqlForOutputMapping.InvalidAccessToken';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.GetSnowflakeSqlForOutputMapping.InvalidAccountName';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INVALID_IDENTIFIER =
    'europa.space.GetSnowflakeSqlForOutputMapping.InvalidIdentifier';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.GetSnowflakeSqlForOutputMapping.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.GetSnowflakeSqlForOutputMapping.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_MISSING_COLUMN =
    'europa.space.GetSnowflakeSqlForOutputMapping.MissingColumn';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.GetSnowflakeSqlForOutputMapping.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.GetSnowflakeSqlForOutputMapping.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlForOutputMapping.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.GetSnowflakeSqlForOutputMapping.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.GetSnowflakeSqlForOutputMapping.ObjectAlreadyExists';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeSqlForOutputMapping.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.GetSnowflakeSqlForOutputMapping.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.GetSnowflakeSqlForOutputMapping.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.GetSnowflakeSqlForOutputMapping.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_TIMEOUT =
    'europa.space.GetSnowflakeSqlForOutputMapping.Timeout';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.GetSnowflakeSqlForOutputMapping.UncategorizedSqlError';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSnowflakeSqlForOutputMapping.UnexpectedFailure';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.GetSnowflakeSqlForOutputMapping.UnknownFunction';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.GetSnowflakeSqlForOutputMapping.UnknownFunctions';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.GetSnowflakeSqlForOutputMapping.UserDiffersFromToken';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.GetSnowflakeSqlForOutputMapping.ValueNotRecognized';
export const GET_SNOWFLAKE_SQL_FOR_OUTPUT_MAPPING_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.GetSnowflakeSqlForOutputMapping.WarehouseSuspended';
export const GET_SNOWFLAKE_TABLE_ACCESS_SUCCESS_ACCESSIBLE =
    'europa.space.GetSnowflakeTableAccess.Accessible';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.GetSnowflakeTableAccess.AmbiguousColumnReference';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.GetSnowflakeTableAccess.CannotCastValueOfType';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.GetSnowflakeTableAccess.ClientConnectionError';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.GetSnowflakeTableAccess.CompilationFailedWithDatasetError';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_DATA_LOADING_FAILED =
    'europa.space.GetSnowflakeTableAccess.DataLoadingFailed';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeTableAccess.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_TABLE_ACCESS_SUCCESS_DEPLOYMENT_DETAILS =
    'europa.space.GetSnowflakeTableAccess.DeploymentDetails';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeTableAccess.EntityNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.GetSnowflakeTableAccess.InsufficientPrivileges';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.GetSnowflakeTableAccess.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.GetSnowflakeTableAccess.InvalidAccessToken';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.GetSnowflakeTableAccess.InvalidAccountName';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INVALID_IDENTIFIER =
    'europa.space.GetSnowflakeTableAccess.InvalidIdentifier';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.GetSnowflakeTableAccess.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.GetSnowflakeTableAccess.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_MISSING_COLUMN =
    'europa.space.GetSnowflakeTableAccess.MissingColumn';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.GetSnowflakeTableAccess.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_NO_DEPLOYMENT_HISTORY =
    'europa.space.GetSnowflakeTableAccess.NoDeploymentHistory';
export const GET_SNOWFLAKE_TABLE_ACCESS_SUCCESS_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeTableAccess.NotAccessible';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.GetSnowflakeTableAccess.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeTableAccess.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.GetSnowflakeTableAccess.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.GetSnowflakeTableAccess.ObjectAlreadyExists';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.GetSnowflakeTableAccess.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.GetSnowflakeTableAccess.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.GetSnowflakeTableAccess.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSnowflakeTableAccess.SnowflakeObjectNotFoundOrNotAccessible';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.GetSnowflakeTableAccess.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_TIMEOUT =
    'europa.space.GetSnowflakeTableAccess.Timeout';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.GetSnowflakeTableAccess.UncategorizedSqlError';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSnowflakeTableAccess.UnexpectedFailure';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.GetSnowflakeTableAccess.UnknownFunction';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.GetSnowflakeTableAccess.UnknownFunctions';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.GetSnowflakeTableAccess.UserDiffersFromToken';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.GetSnowflakeTableAccess.ValueNotRecognized';
export const GET_SNOWFLAKE_TABLE_ACCESS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.GetSnowflakeTableAccess.WarehouseSuspended';
export const GET_SPACE_FAILURE_ASSET_NOT_FOUND_BY_SLUG =
    'europa.space.GetSpace.AssetNotFoundBySlug';
export const GET_SPACE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetSpace.EntityNotFoundOrNotAccessible';
export const GET_SPACE_FAILURE_NO_DEPLOYMENT_HISTORY = 'europa.space.GetSpace.NoDeploymentHistory';
export const GET_SPACE_SUCCESS_SPACE_DTO = 'europa.space.GetSpace.SpaceDto';
export const GET_SPACE_FAILURE_UNEXPECTED_FAILURE = 'europa.space.GetSpace.UnexpectedFailure';
export const GET_SPACE_REFS_SUCCESS_SPACE_REF_DTOS = 'europa.space.GetSpaceRefs.SpaceRefDtos';
export const GET_SPACE_REFS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetSpaceRefs.UnexpectedFailure';
export const GET_TABLE_DETAILS_FAILURE_NO_DEPLOYMENT_HISTORY =
    'europa.space.GetTableDetails.NoDeploymentHistory';
export const GET_TABLE_DETAILS_SUCCESS_TABLE_DETAILS = 'europa.space.GetTableDetails.TableDetails';
export const GET_TABLE_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.GetTableDetails.UnexpectedFailure';
export const GET_VIEW_FAILURE_ASSET_NOT_FOUND_BY_SLUG = 'europa.space.GetView.AssetNotFoundBySlug';
export const GET_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.GetView.EntityNotFoundOrNotAccessible';
export const GET_VIEW_FAILURE_NO_DEPLOYMENT_HISTORY = 'europa.space.GetView.NoDeploymentHistory';
export const GET_VIEW_FAILURE_UNEXPECTED_FAILURE = 'europa.space.GetView.UnexpectedFailure';
export const GET_VIEW_SUCCESS_VIEW = 'europa.space.GetView.View';
export const IMPORT_DATASET_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ImportDataset.AmbiguousColumnReference';
export const IMPORT_DATASET_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ImportDataset.CannotCastValueOfType';
export const IMPORT_DATASET_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportDataset.DatabaseNotExistsOrNotAuthorized';
export const IMPORT_DATASET_FAILURE_INVALID_IDENTIFIER =
    'europa.space.ImportDataset.InvalidIdentifier';
export const IMPORT_DATASET_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ImportDataset.InvalidParameterTypeForFunction';
export const IMPORT_DATASET_FAILURE_MISSING_COLUMN = 'europa.space.ImportDataset.MissingColumn';
export const IMPORT_DATASET_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportDataset.NotExistsOrNotAuthorized';
export const IMPORT_DATASET_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportDataset.SchemaNotExistsOrNotAuthorized';
export const IMPORT_DATASET_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ImportDataset.UncategorizedSqlError';
export const IMPORT_DATASET_FAILURE_UNKNOWN_FUNCTION = 'europa.space.ImportDataset.UnknownFunction';
export const IMPORT_DATASET_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.ImportDataset.UnknownFunctions';
export const IMPORT_DATASET_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ImportDataset.ValueNotRecognized';
export const IMPORT_DATASETS_SUCCESS_IMPORT_OF_DATASETS_STARTED =
    'europa.space.ImportDatasets.ImportOfDatasetsStarted';
export const IMPORT_DATASETS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ImportDatasets.UnexpectedFailure';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ImportTableToNewProject.AmbiguousColumnReference';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.ImportTableToNewProject.AssetModificationNotPermitted';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ImportTableToNewProject.CannotCastValueOfType';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.ImportTableToNewProject.ClientConnectionError';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.ImportTableToNewProject.DataLoadingFailed';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToNewProject.DatabaseNotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.ImportTableToNewProject.DerivedAssetMustNotBeModified';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ImportTableToNewProject.EntityNotFoundOrNotAccessible';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.ImportTableToNewProject.InsufficientPrivileges';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.ImportTableToNewProject.InsufficientTaskPrivileges';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.ImportTableToNewProject.InvalidAccessToken';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.ImportTableToNewProject.InvalidAccountName';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INVALID_IDENTIFIER =
    'europa.space.ImportTableToNewProject.InvalidIdentifier';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ImportTableToNewProject.InvalidParameterTypeForFunction';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.ImportTableToNewProject.MaxFileSizeExceeded';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_MISSING_COLUMN =
    'europa.space.ImportTableToNewProject.MissingColumn';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.ImportTableToNewProject.NoActiveWarehouseSelected';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.ImportTableToNewProject.NotAuthenticatedToSnowflake';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToNewProject.NotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.ImportTableToNewProject.NotExistsOrOperationCannotBePerformed';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.ImportTableToNewProject.ObjectAlreadyExists';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToNewProject.SchemaNotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.ImportTableToNewProject.SnowflakeInternalServerError';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.ImportTableToNewProject.SnowflakeNotConfigured';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.ImportTableToNewProject.SnowflakeQueryCanceled';
export const IMPORT_TABLE_TO_NEW_PROJECT_SUCCESS_TABLE_IMPORTED_TO_NEW_PROJECT =
    'europa.space.ImportTableToNewProject.TableImportedToNewProject';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_TIMEOUT =
    'europa.space.ImportTableToNewProject.Timeout';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ImportTableToNewProject.UncategorizedSqlError';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ImportTableToNewProject.UnexpectedFailure';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.ImportTableToNewProject.UnknownFunction';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.ImportTableToNewProject.UnknownFunctions';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.ImportTableToNewProject.UserDiffersFromToken';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ImportTableToNewProject.ValueNotRecognized';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_VIEW_ALREADY_EXISTS =
    'europa.space.ImportTableToNewProject.ViewAlreadyExists';
export const IMPORT_TABLE_TO_NEW_PROJECT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.ImportTableToNewProject.WarehouseSuspended';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ImportTableToProject.AmbiguousColumnReference';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.ImportTableToProject.AssetModificationNotPermitted';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ImportTableToProject.CannotCastValueOfType';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.ImportTableToProject.ClientConnectionError';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.ImportTableToProject.DataLoadingFailed';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToProject.DatabaseNotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ImportTableToProject.EntityNotFoundOrNotAccessible';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.ImportTableToProject.InsufficientPrivileges';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.ImportTableToProject.InsufficientTaskPrivileges';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.ImportTableToProject.InvalidAccessToken';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.ImportTableToProject.InvalidAccountName';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INVALID_IDENTIFIER =
    'europa.space.ImportTableToProject.InvalidIdentifier';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ImportTableToProject.InvalidParameterTypeForFunction';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.ImportTableToProject.MaxFileSizeExceeded';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_MISSING_COLUMN =
    'europa.space.ImportTableToProject.MissingColumn';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.ImportTableToProject.NoActiveWarehouseSelected';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.ImportTableToProject.NotAuthenticatedToSnowflake';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToProject.NotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.ImportTableToProject.NotExistsOrOperationCannotBePerformed';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.ImportTableToProject.ObjectAlreadyExists';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportTableToProject.SchemaNotExistsOrNotAuthorized';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.ImportTableToProject.SnowflakeInternalServerError';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.ImportTableToProject.SnowflakeNotConfigured';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.ImportTableToProject.SnowflakeQueryCanceled';
export const IMPORT_TABLE_TO_PROJECT_SUCCESS_TABLE_IMPORTED_TO_PROJECT =
    'europa.space.ImportTableToProject.TableImportedToProject';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_TIMEOUT = 'europa.space.ImportTableToProject.Timeout';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ImportTableToProject.UncategorizedSqlError';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ImportTableToProject.UnexpectedFailure';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.ImportTableToProject.UnknownFunction';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.ImportTableToProject.UnknownFunctions';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.ImportTableToProject.UserDiffersFromToken';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ImportTableToProject.ValueNotRecognized';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_VIEW_ALREADY_EXISTS =
    'europa.space.ImportTableToProject.ViewAlreadyExists';
export const IMPORT_TABLE_TO_PROJECT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.ImportTableToProject.WarehouseSuspended';
export const IMPORT_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ImportView.AmbiguousColumnReference';
export const IMPORT_VIEW_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.ImportView.AssetModificationNotPermitted';
export const IMPORT_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ImportView.CannotCastValueOfType';
export const IMPORT_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.ImportView.ClientConnectionError';
export const IMPORT_VIEW_FAILURE_DATA_LOADING_FAILED = 'europa.space.ImportView.DataLoadingFailed';
export const IMPORT_VIEW_SUCCESS_DATA_SOURCE_IMPORTED =
    'europa.space.ImportView.DataSourceImported';
export const IMPORT_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportView.DatabaseNotExistsOrNotAuthorized';
export const IMPORT_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ImportView.EntityNotFoundOrNotAccessible';
export const IMPORT_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.ImportView.InsufficientPrivileges';
export const IMPORT_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.ImportView.InsufficientTaskPrivileges';
export const IMPORT_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.ImportView.InvalidAccessToken';
export const IMPORT_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.ImportView.InvalidAccountName';
export const IMPORT_VIEW_FAILURE_INVALID_IDENTIFIER = 'europa.space.ImportView.InvalidIdentifier';
export const IMPORT_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ImportView.InvalidParameterTypeForFunction';
export const IMPORT_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.ImportView.MaxFileSizeExceeded';
export const IMPORT_VIEW_FAILURE_MISSING_COLUMN = 'europa.space.ImportView.MissingColumn';
export const IMPORT_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.ImportView.NoActiveWarehouseSelected';
export const IMPORT_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.ImportView.NotAuthenticatedToSnowflake';
export const IMPORT_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportView.NotExistsOrNotAuthorized';
export const IMPORT_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.ImportView.NotExistsOrOperationCannotBePerformed';
export const IMPORT_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.ImportView.ObjectAlreadyExists';
export const IMPORT_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ImportView.SchemaNotExistsOrNotAuthorized';
export const IMPORT_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.ImportView.SnowflakeInternalServerError';
export const IMPORT_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.ImportView.SnowflakeNotConfigured';
export const IMPORT_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.ImportView.SnowflakeQueryCanceled';
export const IMPORT_VIEW_SUCCESS_SNOWFLAKE_TABLE_ALREADY_IMPORTED =
    'europa.space.ImportView.SnowflakeTableAlreadyImported';
export const IMPORT_VIEW_FAILURE_TIMEOUT = 'europa.space.ImportView.Timeout';
export const IMPORT_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ImportView.UncategorizedSqlError';
export const IMPORT_VIEW_FAILURE_UNEXPECTED_FAILURE = 'europa.space.ImportView.UnexpectedFailure';
export const IMPORT_VIEW_FAILURE_UNKNOWN_FUNCTION = 'europa.space.ImportView.UnknownFunction';
export const IMPORT_VIEW_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.ImportView.UnknownFunctions';
export const IMPORT_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.ImportView.UserDiffersFromToken';
export const IMPORT_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ImportView.ValueNotRecognized';
export const IMPORT_VIEW_FAILURE_VIEW_ALREADY_EXISTS = 'europa.space.ImportView.ViewAlreadyExists';
export const IMPORT_VIEW_FAILURE_WAREHOUSE_SUSPENDED = 'europa.space.ImportView.WarehouseSuspended';
export const REMOVE_COLLABORATORS_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.RemoveCollaborators.AssetModificationNotPermitted';
export const REMOVE_COLLABORATORS_SUCCESS_COLLABORATORS_REMOVED =
    'europa.space.RemoveCollaborators.CollaboratorsRemoved';
export const REMOVE_COLLABORATORS_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.RemoveCollaborators.DerivedAssetMustNotBeModified';
export const REMOVE_COLLABORATORS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.RemoveCollaborators.EntityNotFoundOrNotAccessible';
export const REMOVE_COLLABORATORS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.RemoveCollaborators.UnexpectedFailure';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.SetViewOutputColumns.AmbiguousColumnReference';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.SetViewOutputColumns.AssetModificationNotPermitted';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_CANCELED =
    'europa.space.SetViewOutputColumns.Canceled';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.SetViewOutputColumns.CannotCastValueOfType';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.SetViewOutputColumns.CircularReference';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.SetViewOutputColumns.ClientConnectionError';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.SetViewOutputColumns.CompilationFailedWithDatasetError';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_DATA_LOADING_FAILED =
    'europa.space.SetViewOutputColumns.DataLoadingFailed';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.SetViewOutputColumns.DatabaseNotExistsOrNotAuthorized';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.SetViewOutputColumns.DuplicateColumnNames';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.SetViewOutputColumns.EntityNotFoundOrNotAccessible';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.SetViewOutputColumns.InsufficientPrivileges';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.SetViewOutputColumns.InsufficientTaskPrivileges';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.SetViewOutputColumns.InvalidAccessToken';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.SetViewOutputColumns.InvalidAccountName';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INVALID_IDENTIFIER =
    'europa.space.SetViewOutputColumns.InvalidIdentifier';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.SetViewOutputColumns.InvalidParameterTypeForFunction';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.SetViewOutputColumns.MaxFileSizeExceeded';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_MISSING_COLUMN =
    'europa.space.SetViewOutputColumns.MissingColumn';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.SetViewOutputColumns.NoActiveWarehouseSelected';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.SetViewOutputColumns.NotAuthenticatedToSnowflake';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.SetViewOutputColumns.NotExistsOrNotAuthorized';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.SetViewOutputColumns.NotExistsOrOperationCannotBePerformed';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.SetViewOutputColumns.ObjectAlreadyExists';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.SetViewOutputColumns.OutputColumnsWithInvisibleControlCharacters';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.SetViewOutputColumns.OutputColumnsWithLineSeparator';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.SetViewOutputColumns.SchemaNotExistsOrNotAuthorized';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.SetViewOutputColumns.SnowflakeInternalServerError';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.SetViewOutputColumns.SnowflakeNotConfigured';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.SetViewOutputColumns.SnowflakeQueryCanceled';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_TIMEOUT = 'europa.space.SetViewOutputColumns.Timeout';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.SetViewOutputColumns.UncategorizedSqlError';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.SetViewOutputColumns.UnexpectedFailure';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.SetViewOutputColumns.UnknownFunction';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.SetViewOutputColumns.UnknownFunctions';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.SetViewOutputColumns.UserDiffersFromToken';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.SetViewOutputColumns.ValueNotRecognized';
export const SET_VIEW_OUTPUT_COLUMNS_SUCCESS_VIEW_OUTPUT_COLUMNS_SET =
    'europa.space.SetViewOutputColumns.ViewOutputColumnsSet';
export const SET_VIEW_OUTPUT_COLUMNS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.SetViewOutputColumns.WarehouseSuspended';
export const SIMULATE_FORMULA_COLUMN_RENAME_FAILURE_COLUMN_NAME_ALREADY_EXISTS =
    'europa.space.SimulateFormulaColumnRename.ColumnNameAlreadyExists';
export const SIMULATE_FORMULA_COLUMN_RENAME_SUCCESS_RENAME_SUCCESSFUL =
    'europa.space.SimulateFormulaColumnRename.RenameSuccessful';
export const SIMULATE_FORMULA_COLUMN_RENAME_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.SimulateFormulaColumnRename.UnexpectedFailure';
export const SYNC_PROJECT_SUCCESS_PROJECT_SYNCED = 'europa.space.SyncProject.ProjectSynced';
export const SYNC_PROJECT_FAILURE_UNEXPECTED_FAILURE = 'europa.space.SyncProject.UnexpectedFailure';
export const UPDATE_AGGREGATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateAggregation.AmbiguousColumnReference';
export const UPDATE_AGGREGATION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateAggregation.AssetModificationNotPermitted';
export const UPDATE_AGGREGATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateAggregation.CannotCastValueOfType';
export const UPDATE_AGGREGATION_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateAggregation.CircularReference';
export const UPDATE_AGGREGATION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateAggregation.ClientConnectionError';
export const UPDATE_AGGREGATION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateAggregation.CompilationFailedWithDatasetError';
export const UPDATE_AGGREGATION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateAggregation.DataLoadingFailed';
export const UPDATE_AGGREGATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateAggregation.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_AGGREGATION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateAggregation.DuplicateColumnNames';
export const UPDATE_AGGREGATION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateAggregation.EntityNotFoundOrNotAccessible';
export const UPDATE_AGGREGATION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateAggregation.InsufficientPrivileges';
export const UPDATE_AGGREGATION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateAggregation.InsufficientTaskPrivileges';
export const UPDATE_AGGREGATION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateAggregation.InvalidAccessToken';
export const UPDATE_AGGREGATION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateAggregation.InvalidAccountName';
export const UPDATE_AGGREGATION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateAggregation.InvalidIdentifier';
export const UPDATE_AGGREGATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateAggregation.InvalidParameterTypeForFunction';
export const UPDATE_AGGREGATION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateAggregation.MaxFileSizeExceeded';
export const UPDATE_AGGREGATION_FAILURE_MISSING_COLUMN =
    'europa.space.UpdateAggregation.MissingColumn';
export const UPDATE_AGGREGATION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateAggregation.NoActiveWarehouseSelected';
export const UPDATE_AGGREGATION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateAggregation.NotAuthenticatedToSnowflake';
export const UPDATE_AGGREGATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateAggregation.NotExistsOrNotAuthorized';
export const UPDATE_AGGREGATION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateAggregation.NotExistsOrOperationCannotBePerformed';
export const UPDATE_AGGREGATION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateAggregation.ObjectAlreadyExists';
export const UPDATE_AGGREGATION_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateAggregation.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_AGGREGATION_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateAggregation.OutputColumnsWithLineSeparator';
export const UPDATE_AGGREGATION_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateAggregation.RequirementNotMet';
export const UPDATE_AGGREGATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateAggregation.SchemaNotExistsOrNotAuthorized';
export const UPDATE_AGGREGATION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateAggregation.SnowflakeInternalServerError';
export const UPDATE_AGGREGATION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateAggregation.SnowflakeNotConfigured';
export const UPDATE_AGGREGATION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateAggregation.SnowflakeQueryCanceled';
export const UPDATE_AGGREGATION_FAILURE_TIMEOUT = 'europa.space.UpdateAggregation.Timeout';
export const UPDATE_AGGREGATION_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateAggregation.TransformationUpdated';
export const UPDATE_AGGREGATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateAggregation.UncategorizedSqlError';
export const UPDATE_AGGREGATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateAggregation.UnexpectedFailure';
export const UPDATE_AGGREGATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateAggregation.UnknownFunction';
export const UPDATE_AGGREGATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateAggregation.UnknownFunctions';
export const UPDATE_AGGREGATION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateAggregation.UserDiffersFromToken';
export const UPDATE_AGGREGATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateAggregation.ValueNotRecognized';
export const UPDATE_AGGREGATION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateAggregation.WarehouseSuspended';
export const UPDATE_BLEND_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateBlend.AmbiguousColumnReference';
export const UPDATE_BLEND_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateBlend.AssetModificationNotPermitted';
export const UPDATE_BLEND_FAILURE_BLEND_CONDITIONS_EMPTY =
    'europa.space.UpdateBlend.BlendConditionsEmpty';
export const UPDATE_BLEND_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateBlend.CannotCastValueOfType';
export const UPDATE_BLEND_FAILURE_CIRCULAR_REFERENCE = 'europa.space.UpdateBlend.CircularReference';
export const UPDATE_BLEND_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateBlend.ClientConnectionError';
export const UPDATE_BLEND_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateBlend.CompilationFailedWithDatasetError';
export const UPDATE_BLEND_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateBlend.DataLoadingFailed';
export const UPDATE_BLEND_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateBlend.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_BLEND_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateBlend.DuplicateColumnNames';
export const UPDATE_BLEND_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateBlend.EntityNotFoundOrNotAccessible';
export const UPDATE_BLEND_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateBlend.InsufficientPrivileges';
export const UPDATE_BLEND_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateBlend.InsufficientTaskPrivileges';
export const UPDATE_BLEND_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateBlend.InvalidAccessToken';
export const UPDATE_BLEND_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateBlend.InvalidAccountName';
export const UPDATE_BLEND_FAILURE_INVALID_IDENTIFIER = 'europa.space.UpdateBlend.InvalidIdentifier';
export const UPDATE_BLEND_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateBlend.InvalidParameterTypeForFunction';
export const UPDATE_BLEND_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateBlend.MaxFileSizeExceeded';
export const UPDATE_BLEND_FAILURE_MISSING_COLUMN = 'europa.space.UpdateBlend.MissingColumn';
export const UPDATE_BLEND_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateBlend.NoActiveWarehouseSelected';
export const UPDATE_BLEND_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateBlend.NotAuthenticatedToSnowflake';
export const UPDATE_BLEND_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateBlend.NotExistsOrNotAuthorized';
export const UPDATE_BLEND_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateBlend.NotExistsOrOperationCannotBePerformed';
export const UPDATE_BLEND_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateBlend.ObjectAlreadyExists';
export const UPDATE_BLEND_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateBlend.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_BLEND_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateBlend.OutputColumnsWithLineSeparator';
export const UPDATE_BLEND_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateBlend.RequirementNotMet';
export const UPDATE_BLEND_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateBlend.SchemaNotExistsOrNotAuthorized';
export const UPDATE_BLEND_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateBlend.SnowflakeInternalServerError';
export const UPDATE_BLEND_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateBlend.SnowflakeNotConfigured';
export const UPDATE_BLEND_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateBlend.SnowflakeQueryCanceled';
export const UPDATE_BLEND_FAILURE_TIMEOUT = 'europa.space.UpdateBlend.Timeout';
export const UPDATE_BLEND_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateBlend.TransformationUpdated';
export const UPDATE_BLEND_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateBlend.UncategorizedSqlError';
export const UPDATE_BLEND_FAILURE_UNEXPECTED_FAILURE = 'europa.space.UpdateBlend.UnexpectedFailure';
export const UPDATE_BLEND_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdateBlend.UnknownFunction';
export const UPDATE_BLEND_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.UpdateBlend.UnknownFunctions';
export const UPDATE_BLEND_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateBlend.UserDiffersFromToken';
export const UPDATE_BLEND_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateBlend.ValueNotRecognized';
export const UPDATE_BLEND_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateBlend.WarehouseSuspended';
export const UPDATE_DATA_SOURCE_REFERENCE_SCHEMA_SUCCESS_SOURCE_SCHEMA_UPDATED =
    'europa.space.UpdateDataSourceReferenceSchema.SourceSchemaUpdated';
export const UPDATE_DATA_SOURCE_REFERENCE_SCHEMA_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateDataSourceReferenceSchema.UnexpectedFailure';
export const UPDATE_FILTER_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateFilter.AmbiguousColumnReference';
export const UPDATE_FILTER_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateFilter.AssetModificationNotPermitted';
export const UPDATE_FILTER_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateFilter.CannotCastValueOfType';
export const UPDATE_FILTER_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateFilter.CircularReference';
export const UPDATE_FILTER_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateFilter.ClientConnectionError';
export const UPDATE_FILTER_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateFilter.CompilationFailedWithDatasetError';
export const UPDATE_FILTER_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateFilter.DataLoadingFailed';
export const UPDATE_FILTER_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFilter.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_FILTER_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateFilter.DuplicateColumnNames';
export const UPDATE_FILTER_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateFilter.EntityNotFoundOrNotAccessible';
export const UPDATE_FILTER_FAILURE_FILTER_VALUE_HAS_INCOMPATIBLE_TYPE =
    'europa.space.UpdateFilter.FilterValueHasIncompatibleType';
export const UPDATE_FILTER_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateFilter.InsufficientPrivileges';
export const UPDATE_FILTER_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateFilter.InsufficientTaskPrivileges';
export const UPDATE_FILTER_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateFilter.InvalidAccessToken';
export const UPDATE_FILTER_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateFilter.InvalidAccountName';
export const UPDATE_FILTER_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateFilter.InvalidIdentifier';
export const UPDATE_FILTER_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateFilter.InvalidParameterTypeForFunction';
export const UPDATE_FILTER_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateFilter.MaxFileSizeExceeded';
export const UPDATE_FILTER_FAILURE_MISSING_COLUMN = 'europa.space.UpdateFilter.MissingColumn';
export const UPDATE_FILTER_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateFilter.NoActiveWarehouseSelected';
export const UPDATE_FILTER_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateFilter.NotAuthenticatedToSnowflake';
export const UPDATE_FILTER_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFilter.NotExistsOrNotAuthorized';
export const UPDATE_FILTER_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateFilter.NotExistsOrOperationCannotBePerformed';
export const UPDATE_FILTER_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateFilter.ObjectAlreadyExists';
export const UPDATE_FILTER_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateFilter.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_FILTER_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateFilter.OutputColumnsWithLineSeparator';
export const UPDATE_FILTER_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateFilter.RequirementNotMet';
export const UPDATE_FILTER_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFilter.SchemaNotExistsOrNotAuthorized';
export const UPDATE_FILTER_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateFilter.SnowflakeInternalServerError';
export const UPDATE_FILTER_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateFilter.SnowflakeNotConfigured';
export const UPDATE_FILTER_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateFilter.SnowflakeQueryCanceled';
export const UPDATE_FILTER_FAILURE_TIMEOUT = 'europa.space.UpdateFilter.Timeout';
export const UPDATE_FILTER_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateFilter.TransformationUpdated';
export const UPDATE_FILTER_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateFilter.UncategorizedSqlError';
export const UPDATE_FILTER_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateFilter.UnexpectedFailure';
export const UPDATE_FILTER_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdateFilter.UnknownFunction';
export const UPDATE_FILTER_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.UpdateFilter.UnknownFunctions';
export const UPDATE_FILTER_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateFilter.UserDiffersFromToken';
export const UPDATE_FILTER_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateFilter.ValueNotRecognized';
export const UPDATE_FILTER_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateFilter.WarehouseSuspended';
export const UPDATE_FORMULA_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateFormula.AmbiguousColumnReference';
export const UPDATE_FORMULA_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateFormula.AssetModificationNotPermitted';
export const UPDATE_FORMULA_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateFormula.CannotCastValueOfType';
export const UPDATE_FORMULA_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateFormula.CircularReference';
export const UPDATE_FORMULA_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateFormula.ClientConnectionError';
export const UPDATE_FORMULA_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateFormula.CompilationFailedWithDatasetError';
export const UPDATE_FORMULA_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateFormula.DataLoadingFailed';
export const UPDATE_FORMULA_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFormula.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_FORMULA_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateFormula.DuplicateColumnNames';
export const UPDATE_FORMULA_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateFormula.EntityNotFoundOrNotAccessible';
export const UPDATE_FORMULA_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateFormula.InsufficientPrivileges';
export const UPDATE_FORMULA_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateFormula.InsufficientTaskPrivileges';
export const UPDATE_FORMULA_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateFormula.InvalidAccessToken';
export const UPDATE_FORMULA_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateFormula.InvalidAccountName';
export const UPDATE_FORMULA_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateFormula.InvalidIdentifier';
export const UPDATE_FORMULA_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateFormula.InvalidParameterTypeForFunction';
export const UPDATE_FORMULA_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateFormula.MaxFileSizeExceeded';
export const UPDATE_FORMULA_FAILURE_MISSING_COLUMN = 'europa.space.UpdateFormula.MissingColumn';
export const UPDATE_FORMULA_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateFormula.NoActiveWarehouseSelected';
export const UPDATE_FORMULA_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateFormula.NotAuthenticatedToSnowflake';
export const UPDATE_FORMULA_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFormula.NotExistsOrNotAuthorized';
export const UPDATE_FORMULA_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateFormula.NotExistsOrOperationCannotBePerformed';
export const UPDATE_FORMULA_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateFormula.ObjectAlreadyExists';
export const UPDATE_FORMULA_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateFormula.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_FORMULA_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateFormula.OutputColumnsWithLineSeparator';
export const UPDATE_FORMULA_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateFormula.RequirementNotMet';
export const UPDATE_FORMULA_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateFormula.SchemaNotExistsOrNotAuthorized';
export const UPDATE_FORMULA_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateFormula.SnowflakeInternalServerError';
export const UPDATE_FORMULA_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateFormula.SnowflakeNotConfigured';
export const UPDATE_FORMULA_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateFormula.SnowflakeQueryCanceled';
export const UPDATE_FORMULA_FAILURE_TIMEOUT = 'europa.space.UpdateFormula.Timeout';
export const UPDATE_FORMULA_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateFormula.TransformationUpdated';
export const UPDATE_FORMULA_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateFormula.UncategorizedSqlError';
export const UPDATE_FORMULA_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateFormula.UnexpectedFailure';
export const UPDATE_FORMULA_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdateFormula.UnknownFunction';
export const UPDATE_FORMULA_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateFormula.UnknownFunctions';
export const UPDATE_FORMULA_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateFormula.UserDiffersFromToken';
export const UPDATE_FORMULA_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateFormula.ValueNotRecognized';
export const UPDATE_FORMULA_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateFormula.WarehouseSuspended';
export const UPDATE_GROUP_DESCRIPTION_SUCCESS_GROUP_DESCRIPTION_UPDATED =
    'europa.space.UpdateGroupDescription.GroupDescriptionUpdated';
export const UPDATE_GROUP_DESCRIPTION_FAILURE_GROUP_NOT_FOUND =
    'europa.space.UpdateGroupDescription.GroupNotFound';
export const UPDATE_GROUP_DESCRIPTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateGroupDescription.UnexpectedFailure';
export const UPDATE_GROUP_NAME_SUCCESS_GROUP_NAME_UPDATED =
    'europa.space.UpdateGroupName.GroupNameUpdated';
export const UPDATE_GROUP_NAME_FAILURE_GROUP_NOT_FOUND =
    'europa.space.UpdateGroupName.GroupNotFound';
export const UPDATE_GROUP_NAME_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateGroupName.UnexpectedFailure';
export const UPDATE_PIVOT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdatePivot.AmbiguousColumnReference';
export const UPDATE_PIVOT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdatePivot.AssetModificationNotPermitted';
export const UPDATE_PIVOT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdatePivot.CannotCastValueOfType';
export const UPDATE_PIVOT_FAILURE_CIRCULAR_REFERENCE = 'europa.space.UpdatePivot.CircularReference';
export const UPDATE_PIVOT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdatePivot.ClientConnectionError';
export const UPDATE_PIVOT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdatePivot.CompilationFailedWithDatasetError';
export const UPDATE_PIVOT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdatePivot.DataLoadingFailed';
export const UPDATE_PIVOT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdatePivot.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_PIVOT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdatePivot.DuplicateColumnNames';
export const UPDATE_PIVOT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdatePivot.EntityNotFoundOrNotAccessible';
export const UPDATE_PIVOT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdatePivot.InsufficientPrivileges';
export const UPDATE_PIVOT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdatePivot.InsufficientTaskPrivileges';
export const UPDATE_PIVOT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdatePivot.InvalidAccessToken';
export const UPDATE_PIVOT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdatePivot.InvalidAccountName';
export const UPDATE_PIVOT_FAILURE_INVALID_IDENTIFIER = 'europa.space.UpdatePivot.InvalidIdentifier';
export const UPDATE_PIVOT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdatePivot.InvalidParameterTypeForFunction';
export const UPDATE_PIVOT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdatePivot.MaxFileSizeExceeded';
export const UPDATE_PIVOT_FAILURE_MISSING_COLUMN = 'europa.space.UpdatePivot.MissingColumn';
export const UPDATE_PIVOT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdatePivot.NoActiveWarehouseSelected';
export const UPDATE_PIVOT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdatePivot.NotAuthenticatedToSnowflake';
export const UPDATE_PIVOT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdatePivot.NotExistsOrNotAuthorized';
export const UPDATE_PIVOT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdatePivot.NotExistsOrOperationCannotBePerformed';
export const UPDATE_PIVOT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdatePivot.ObjectAlreadyExists';
export const UPDATE_PIVOT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdatePivot.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_PIVOT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdatePivot.OutputColumnsWithLineSeparator';
export const UPDATE_PIVOT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdatePivot.RequirementNotMet';
export const UPDATE_PIVOT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdatePivot.SchemaNotExistsOrNotAuthorized';
export const UPDATE_PIVOT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdatePivot.SnowflakeInternalServerError';
export const UPDATE_PIVOT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdatePivot.SnowflakeNotConfigured';
export const UPDATE_PIVOT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdatePivot.SnowflakeQueryCanceled';
export const UPDATE_PIVOT_FAILURE_TIMEOUT = 'europa.space.UpdatePivot.Timeout';
export const UPDATE_PIVOT_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdatePivot.TransformationUpdated';
export const UPDATE_PIVOT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdatePivot.UncategorizedSqlError';
export const UPDATE_PIVOT_FAILURE_UNEXPECTED_FAILURE = 'europa.space.UpdatePivot.UnexpectedFailure';
export const UPDATE_PIVOT_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdatePivot.UnknownFunction';
export const UPDATE_PIVOT_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.UpdatePivot.UnknownFunctions';
export const UPDATE_PIVOT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdatePivot.UserDiffersFromToken';
export const UPDATE_PIVOT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdatePivot.ValueNotRecognized';
export const UPDATE_PIVOT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdatePivot.WarehouseSuspended';
export const UPDATE_PROJECT_ENV_SUCCESS_SUCCEEDED = 'europa.space.UpdateProjectEnv.Succeeded';
export const UPDATE_PROJECT_ENV_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateProjectEnv.UnexpectedFailure';
export const UPDATE_PROJECT_NAME_FAILURE_ALREADY_UP_TO_DATE =
    'europa.space.UpdateProjectName.AlreadyUpToDate';
export const UPDATE_PROJECT_NAME_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateProjectName.AssetModificationNotPermitted';
export const UPDATE_PROJECT_NAME_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateProjectName.EntityNotFoundOrNotAccessible';
export const UPDATE_PROJECT_NAME_SUCCESS_PROJECT_NAME_UPDATED =
    'europa.space.UpdateProjectName.ProjectNameUpdated';
export const UPDATE_PROJECT_NAME_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateProjectName.UnexpectedFailure';
export const UPDATE_PROJECT_OWNER_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateProjectOwner.AssetModificationNotPermitted';
export const UPDATE_PROJECT_OWNER_FAILURE_DERIVED_ASSET_MUST_NOT_BE_MODIFIED =
    'europa.space.UpdateProjectOwner.DerivedAssetMustNotBeModified';
export const UPDATE_PROJECT_OWNER_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateProjectOwner.EntityNotFoundOrNotAccessible';
export const UPDATE_PROJECT_OWNER_SUCCESS_PROJECT_OWNER_UPDATED =
    'europa.space.UpdateProjectOwner.ProjectOwnerUpdated';
export const UPDATE_PROJECT_OWNER_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateProjectOwner.UnexpectedFailure';
export const UPDATE_PROJECTION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateProjection.AmbiguousColumnReference';
export const UPDATE_PROJECTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateProjection.AssetModificationNotPermitted';
export const UPDATE_PROJECTION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateProjection.CannotCastValueOfType';
export const UPDATE_PROJECTION_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateProjection.CircularReference';
export const UPDATE_PROJECTION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateProjection.ClientConnectionError';
export const UPDATE_PROJECTION_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateProjection.CompilationFailedWithDatasetError';
export const UPDATE_PROJECTION_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateProjection.DataLoadingFailed';
export const UPDATE_PROJECTION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateProjection.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_PROJECTION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateProjection.DuplicateColumnNames';
export const UPDATE_PROJECTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateProjection.EntityNotFoundOrNotAccessible';
export const UPDATE_PROJECTION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateProjection.InsufficientPrivileges';
export const UPDATE_PROJECTION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateProjection.InsufficientTaskPrivileges';
export const UPDATE_PROJECTION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateProjection.InvalidAccessToken';
export const UPDATE_PROJECTION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateProjection.InvalidAccountName';
export const UPDATE_PROJECTION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateProjection.InvalidIdentifier';
export const UPDATE_PROJECTION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateProjection.InvalidParameterTypeForFunction';
export const UPDATE_PROJECTION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateProjection.MaxFileSizeExceeded';
export const UPDATE_PROJECTION_FAILURE_MISSING_COLUMN =
    'europa.space.UpdateProjection.MissingColumn';
export const UPDATE_PROJECTION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateProjection.NoActiveWarehouseSelected';
export const UPDATE_PROJECTION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateProjection.NotAuthenticatedToSnowflake';
export const UPDATE_PROJECTION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateProjection.NotExistsOrNotAuthorized';
export const UPDATE_PROJECTION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateProjection.NotExistsOrOperationCannotBePerformed';
export const UPDATE_PROJECTION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateProjection.ObjectAlreadyExists';
export const UPDATE_PROJECTION_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateProjection.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_PROJECTION_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateProjection.OutputColumnsWithLineSeparator';
export const UPDATE_PROJECTION_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateProjection.RequirementNotMet';
export const UPDATE_PROJECTION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateProjection.SchemaNotExistsOrNotAuthorized';
export const UPDATE_PROJECTION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateProjection.SnowflakeInternalServerError';
export const UPDATE_PROJECTION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateProjection.SnowflakeNotConfigured';
export const UPDATE_PROJECTION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateProjection.SnowflakeQueryCanceled';
export const UPDATE_PROJECTION_FAILURE_TIMEOUT = 'europa.space.UpdateProjection.Timeout';
export const UPDATE_PROJECTION_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateProjection.TransformationUpdated';
export const UPDATE_PROJECTION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateProjection.UncategorizedSqlError';
export const UPDATE_PROJECTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateProjection.UnexpectedFailure';
export const UPDATE_PROJECTION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateProjection.UnknownFunction';
export const UPDATE_PROJECTION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateProjection.UnknownFunctions';
export const UPDATE_PROJECTION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateProjection.UserDiffersFromToken';
export const UPDATE_PROJECTION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateProjection.ValueNotRecognized';
export const UPDATE_PROJECTION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateProjection.WarehouseSuspended';
export const UPDATE_REPLACE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateReplace.AmbiguousColumnReference';
export const UPDATE_REPLACE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateReplace.AssetModificationNotPermitted';
export const UPDATE_REPLACE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateReplace.CannotCastValueOfType';
export const UPDATE_REPLACE_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateReplace.CircularReference';
export const UPDATE_REPLACE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateReplace.ClientConnectionError';
export const UPDATE_REPLACE_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateReplace.CompilationFailedWithDatasetError';
export const UPDATE_REPLACE_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateReplace.DataLoadingFailed';
export const UPDATE_REPLACE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateReplace.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_REPLACE_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateReplace.DuplicateColumnNames';
export const UPDATE_REPLACE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateReplace.EntityNotFoundOrNotAccessible';
export const UPDATE_REPLACE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateReplace.InsufficientPrivileges';
export const UPDATE_REPLACE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateReplace.InsufficientTaskPrivileges';
export const UPDATE_REPLACE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateReplace.InvalidAccessToken';
export const UPDATE_REPLACE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateReplace.InvalidAccountName';
export const UPDATE_REPLACE_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateReplace.InvalidIdentifier';
export const UPDATE_REPLACE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateReplace.InvalidParameterTypeForFunction';
export const UPDATE_REPLACE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateReplace.MaxFileSizeExceeded';
export const UPDATE_REPLACE_FAILURE_MISSING_COLUMN = 'europa.space.UpdateReplace.MissingColumn';
export const UPDATE_REPLACE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateReplace.NoActiveWarehouseSelected';
export const UPDATE_REPLACE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateReplace.NotAuthenticatedToSnowflake';
export const UPDATE_REPLACE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateReplace.NotExistsOrNotAuthorized';
export const UPDATE_REPLACE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateReplace.NotExistsOrOperationCannotBePerformed';
export const UPDATE_REPLACE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateReplace.ObjectAlreadyExists';
export const UPDATE_REPLACE_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateReplace.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_REPLACE_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateReplace.OutputColumnsWithLineSeparator';
export const UPDATE_REPLACE_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateReplace.RequirementNotMet';
export const UPDATE_REPLACE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateReplace.SchemaNotExistsOrNotAuthorized';
export const UPDATE_REPLACE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateReplace.SnowflakeInternalServerError';
export const UPDATE_REPLACE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateReplace.SnowflakeNotConfigured';
export const UPDATE_REPLACE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateReplace.SnowflakeQueryCanceled';
export const UPDATE_REPLACE_FAILURE_TIMEOUT = 'europa.space.UpdateReplace.Timeout';
export const UPDATE_REPLACE_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateReplace.TransformationUpdated';
export const UPDATE_REPLACE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateReplace.UncategorizedSqlError';
export const UPDATE_REPLACE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateReplace.UnexpectedFailure';
export const UPDATE_REPLACE_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdateReplace.UnknownFunction';
export const UPDATE_REPLACE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateReplace.UnknownFunctions';
export const UPDATE_REPLACE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateReplace.UserDiffersFromToken';
export const UPDATE_REPLACE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateReplace.ValueNotRecognized';
export const UPDATE_REPLACE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateReplace.WarehouseSuspended';
export const UPDATE_SPACE_COMPILATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateSpaceCompilation.AmbiguousColumnReference';
export const UPDATE_SPACE_COMPILATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateSpaceCompilation.CannotCastValueOfType';
export const UPDATE_SPACE_COMPILATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSpaceCompilation.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_SPACE_COMPILATION_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateSpaceCompilation.DuplicateColumnNames';
export const UPDATE_SPACE_COMPILATION_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateSpaceCompilation.InvalidIdentifier';
export const UPDATE_SPACE_COMPILATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateSpaceCompilation.InvalidParameterTypeForFunction';
export const UPDATE_SPACE_COMPILATION_FAILURE_MISSING_COLUMN =
    'europa.space.UpdateSpaceCompilation.MissingColumn';
export const UPDATE_SPACE_COMPILATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSpaceCompilation.NotExistsOrNotAuthorized';
export const UPDATE_SPACE_COMPILATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSpaceCompilation.SchemaNotExistsOrNotAuthorized';
export const UPDATE_SPACE_COMPILATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateSpaceCompilation.UncategorizedSqlError';
export const UPDATE_SPACE_COMPILATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateSpaceCompilation.UnknownFunction';
export const UPDATE_SPACE_COMPILATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateSpaceCompilation.UnknownFunctions';
export const UPDATE_SPACE_COMPILATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateSpaceCompilation.ValueNotRecognized';
export const UPDATE_SPACE_DESCRIPTION_FAILURE_ALREADY_UP_TO_DATE =
    'europa.space.UpdateSpaceDescription.AlreadyUpToDate';
export const UPDATE_SPACE_DESCRIPTION_SUCCESS_ASSET_DESCRIPTION_UPDATED =
    'europa.space.UpdateSpaceDescription.AssetDescriptionUpdated';
export const UPDATE_SPACE_DESCRIPTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateSpaceDescription.AssetModificationNotPermitted';
export const UPDATE_SPACE_DESCRIPTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateSpaceDescription.EntityNotFoundOrNotAccessible';
export const UPDATE_SPACE_DESCRIPTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateSpaceDescription.UnexpectedFailure';
export const UPDATE_SPLIT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateSplit.AmbiguousColumnReference';
export const UPDATE_SPLIT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateSplit.AssetModificationNotPermitted';
export const UPDATE_SPLIT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateSplit.CannotCastValueOfType';
export const UPDATE_SPLIT_FAILURE_CIRCULAR_REFERENCE = 'europa.space.UpdateSplit.CircularReference';
export const UPDATE_SPLIT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateSplit.ClientConnectionError';
export const UPDATE_SPLIT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateSplit.CompilationFailedWithDatasetError';
export const UPDATE_SPLIT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateSplit.DataLoadingFailed';
export const UPDATE_SPLIT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSplit.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_SPLIT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateSplit.DuplicateColumnNames';
export const UPDATE_SPLIT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateSplit.EntityNotFoundOrNotAccessible';
export const UPDATE_SPLIT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateSplit.InsufficientPrivileges';
export const UPDATE_SPLIT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateSplit.InsufficientTaskPrivileges';
export const UPDATE_SPLIT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateSplit.InvalidAccessToken';
export const UPDATE_SPLIT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateSplit.InvalidAccountName';
export const UPDATE_SPLIT_FAILURE_INVALID_IDENTIFIER = 'europa.space.UpdateSplit.InvalidIdentifier';
export const UPDATE_SPLIT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateSplit.InvalidParameterTypeForFunction';
export const UPDATE_SPLIT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateSplit.MaxFileSizeExceeded';
export const UPDATE_SPLIT_FAILURE_MISSING_COLUMN = 'europa.space.UpdateSplit.MissingColumn';
export const UPDATE_SPLIT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateSplit.NoActiveWarehouseSelected';
export const UPDATE_SPLIT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateSplit.NotAuthenticatedToSnowflake';
export const UPDATE_SPLIT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSplit.NotExistsOrNotAuthorized';
export const UPDATE_SPLIT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateSplit.NotExistsOrOperationCannotBePerformed';
export const UPDATE_SPLIT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateSplit.ObjectAlreadyExists';
export const UPDATE_SPLIT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateSplit.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_SPLIT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateSplit.OutputColumnsWithLineSeparator';
export const UPDATE_SPLIT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateSplit.RequirementNotMet';
export const UPDATE_SPLIT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSplit.SchemaNotExistsOrNotAuthorized';
export const UPDATE_SPLIT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateSplit.SnowflakeInternalServerError';
export const UPDATE_SPLIT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateSplit.SnowflakeNotConfigured';
export const UPDATE_SPLIT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateSplit.SnowflakeQueryCanceled';
export const UPDATE_SPLIT_FAILURE_TIMEOUT = 'europa.space.UpdateSplit.Timeout';
export const UPDATE_SPLIT_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateSplit.TransformationUpdated';
export const UPDATE_SPLIT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateSplit.UncategorizedSqlError';
export const UPDATE_SPLIT_FAILURE_UNEXPECTED_FAILURE = 'europa.space.UpdateSplit.UnexpectedFailure';
export const UPDATE_SPLIT_FAILURE_UNKNOWN_FUNCTION = 'europa.space.UpdateSplit.UnknownFunction';
export const UPDATE_SPLIT_FAILURE_UNKNOWN_FUNCTIONS = 'europa.space.UpdateSplit.UnknownFunctions';
export const UPDATE_SPLIT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateSplit.UserDiffersFromToken';
export const UPDATE_SPLIT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateSplit.ValueNotRecognized';
export const UPDATE_SPLIT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateSplit.WarehouseSuspended';
export const UPDATE_SQL_VIEW_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateSqlView.AmbiguousColumnReference';
export const UPDATE_SQL_VIEW_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateSqlView.AssetModificationNotPermitted';
export const UPDATE_SQL_VIEW_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateSqlView.CannotCastValueOfType';
export const UPDATE_SQL_VIEW_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateSqlView.CircularReference';
export const UPDATE_SQL_VIEW_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateSqlView.ClientConnectionError';
export const UPDATE_SQL_VIEW_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateSqlView.CompilationFailedWithDatasetError';
export const UPDATE_SQL_VIEW_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateSqlView.DataLoadingFailed';
export const UPDATE_SQL_VIEW_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSqlView.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_SQL_VIEW_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateSqlView.DuplicateColumnNames';
export const UPDATE_SQL_VIEW_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateSqlView.EntityNotFoundOrNotAccessible';
export const UPDATE_SQL_VIEW_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateSqlView.InsufficientPrivileges';
export const UPDATE_SQL_VIEW_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateSqlView.InsufficientTaskPrivileges';
export const UPDATE_SQL_VIEW_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateSqlView.InvalidAccessToken';
export const UPDATE_SQL_VIEW_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateSqlView.InvalidAccountName';
export const UPDATE_SQL_VIEW_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateSqlView.InvalidIdentifier';
export const UPDATE_SQL_VIEW_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateSqlView.InvalidParameterTypeForFunction';
export const UPDATE_SQL_VIEW_FAILURE_INVALID_SQL_SYNTAX =
    'europa.space.UpdateSqlView.InvalidSqlSyntax';
export const UPDATE_SQL_VIEW_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateSqlView.MaxFileSizeExceeded';
export const UPDATE_SQL_VIEW_FAILURE_MISSING_COLUMN = 'europa.space.UpdateSqlView.MissingColumn';
export const UPDATE_SQL_VIEW_FAILURE_MISSING_TABLE = 'europa.space.UpdateSqlView.MissingTable';
export const UPDATE_SQL_VIEW_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateSqlView.NoActiveWarehouseSelected';
export const UPDATE_SQL_VIEW_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateSqlView.NotAuthenticatedToSnowflake';
export const UPDATE_SQL_VIEW_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSqlView.NotExistsOrNotAuthorized';
export const UPDATE_SQL_VIEW_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateSqlView.NotExistsOrOperationCannotBePerformed';
export const UPDATE_SQL_VIEW_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateSqlView.ObjectAlreadyExists';
export const UPDATE_SQL_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateSqlView.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_SQL_VIEW_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateSqlView.OutputColumnsWithLineSeparator';
export const UPDATE_SQL_VIEW_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateSqlView.RequirementNotMet';
export const UPDATE_SQL_VIEW_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSqlView.SchemaNotExistsOrNotAuthorized';
export const UPDATE_SQL_VIEW_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateSqlView.SnowflakeInternalServerError';
export const UPDATE_SQL_VIEW_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateSqlView.SnowflakeNotConfigured';
export const UPDATE_SQL_VIEW_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateSqlView.SnowflakeQueryCanceled';
export const UPDATE_SQL_VIEW_FAILURE_SQL_NOT_MODIFIED = 'europa.space.UpdateSqlView.SqlNotModified';
export const UPDATE_SQL_VIEW_SUCCESS_SQL_VIEW_UPDATED = 'europa.space.UpdateSqlView.SqlViewUpdated';
export const UPDATE_SQL_VIEW_FAILURE_TIMEOUT = 'europa.space.UpdateSqlView.Timeout';
export const UPDATE_SQL_VIEW_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateSqlView.UncategorizedSqlError';
export const UPDATE_SQL_VIEW_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateSqlView.UnexpectedFailure';
export const UPDATE_SQL_VIEW_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateSqlView.UnknownFunction';
export const UPDATE_SQL_VIEW_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateSqlView.UnknownFunctions';
export const UPDATE_SQL_VIEW_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateSqlView.UserDiffersFromToken';
export const UPDATE_SQL_VIEW_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateSqlView.ValueNotRecognized';
export const UPDATE_SQL_VIEW_FAILURE_VIEW_ALREADY_EXISTS =
    'europa.space.UpdateSqlView.ViewAlreadyExists';
export const UPDATE_SQL_VIEW_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateSqlView.WarehouseSuspended';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateSubstringExtract.AmbiguousColumnReference';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateSubstringExtract.AssetModificationNotPermitted';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateSubstringExtract.CannotCastValueOfType';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateSubstringExtract.CircularReference';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateSubstringExtract.ClientConnectionError';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateSubstringExtract.CompilationFailedWithDatasetError';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateSubstringExtract.DataLoadingFailed';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSubstringExtract.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateSubstringExtract.DuplicateColumnNames';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateSubstringExtract.EntityNotFoundOrNotAccessible';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateSubstringExtract.InsufficientPrivileges';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateSubstringExtract.InsufficientTaskPrivileges';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateSubstringExtract.InvalidAccessToken';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateSubstringExtract.InvalidAccountName';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateSubstringExtract.InvalidIdentifier';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateSubstringExtract.InvalidParameterTypeForFunction';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateSubstringExtract.MaxFileSizeExceeded';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_MISSING_COLUMN =
    'europa.space.UpdateSubstringExtract.MissingColumn';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateSubstringExtract.NoActiveWarehouseSelected';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateSubstringExtract.NotAuthenticatedToSnowflake';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSubstringExtract.NotExistsOrNotAuthorized';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateSubstringExtract.NotExistsOrOperationCannotBePerformed';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateSubstringExtract.ObjectAlreadyExists';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateSubstringExtract.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateSubstringExtract.OutputColumnsWithLineSeparator';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_REQUIREMENT_NOT_MET =
    'europa.space.UpdateSubstringExtract.RequirementNotMet';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateSubstringExtract.SchemaNotExistsOrNotAuthorized';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateSubstringExtract.SnowflakeInternalServerError';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateSubstringExtract.SnowflakeNotConfigured';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateSubstringExtract.SnowflakeQueryCanceled';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_TIMEOUT =
    'europa.space.UpdateSubstringExtract.Timeout';
export const UPDATE_SUBSTRING_EXTRACT_SUCCESS_TRANSFORMATION_UPDATED =
    'europa.space.UpdateSubstringExtract.TransformationUpdated';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateSubstringExtract.UncategorizedSqlError';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateSubstringExtract.UnexpectedFailure';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateSubstringExtract.UnknownFunction';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateSubstringExtract.UnknownFunctions';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateSubstringExtract.UserDiffersFromToken';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateSubstringExtract.ValueNotRecognized';
export const UPDATE_SUBSTRING_EXTRACT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateSubstringExtract.WarehouseSuspended';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateTransformationNode.AmbiguousColumnReference';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateTransformationNode.AssetModificationNotPermitted';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateTransformationNode.CannotCastValueOfType';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateTransformationNode.CircularReference';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateTransformationNode.ClientConnectionError';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateTransformationNode.CompilationFailedWithDatasetError';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS =
    'europa.space.UpdateTransformationNode.CompilationFailedWithTransformationErrors';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateTransformationNode.DataLoadingFailed';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateTransformationNode.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateTransformationNode.DuplicateColumnNames';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateTransformationNode.EntityNotFoundOrNotAccessible';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateTransformationNode.InsufficientPrivileges';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateTransformationNode.InsufficientTaskPrivileges';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateTransformationNode.InvalidAccessToken';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateTransformationNode.InvalidAccountName';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateTransformationNode.InvalidIdentifier';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateTransformationNode.InvalidParameterTypeForFunction';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateTransformationNode.MaxFileSizeExceeded';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_MISSING_COLUMN =
    'europa.space.UpdateTransformationNode.MissingColumn';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateTransformationNode.NoActiveWarehouseSelected';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateTransformationNode.NotAuthenticatedToSnowflake';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateTransformationNode.NotExistsOrNotAuthorized';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateTransformationNode.NotExistsOrOperationCannotBePerformed';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateTransformationNode.ObjectAlreadyExists';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateTransformationNode.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateTransformationNode.OutputColumnsWithLineSeparator';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateTransformationNode.SchemaNotExistsOrNotAuthorized';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateTransformationNode.SnowflakeInternalServerError';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateTransformationNode.SnowflakeNotConfigured';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateTransformationNode.SnowflakeQueryCanceled';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_TIMEOUT =
    'europa.space.UpdateTransformationNode.Timeout';
export const UPDATE_TRANSFORMATION_NODE_SUCCESS_TRANSFORMATION_NODE_UPDATED =
    'europa.space.UpdateTransformationNode.TransformationNodeUpdated';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateTransformationNode.UncategorizedSqlError';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateTransformationNode.UnexpectedFailure';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateTransformationNode.UnknownFunction';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateTransformationNode.UnknownFunctions';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateTransformationNode.UserDiffersFromToken';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateTransformationNode.ValueNotRecognized';
export const UPDATE_TRANSFORMATION_NODE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateTransformationNode.WarehouseSuspended';
export const UPDATE_VIEW_DESCRIPTION_FAILURE_ALREADY_UP_TO_DATE =
    'europa.space.UpdateViewDescription.AlreadyUpToDate';
export const UPDATE_VIEW_DESCRIPTION_SUCCESS_ASSET_DESCRIPTION_UPDATED =
    'europa.space.UpdateViewDescription.AssetDescriptionUpdated';
export const UPDATE_VIEW_DESCRIPTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateViewDescription.AssetModificationNotPermitted';
export const UPDATE_VIEW_DESCRIPTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateViewDescription.EntityNotFoundOrNotAccessible';
export const UPDATE_VIEW_DESCRIPTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateViewDescription.UnexpectedFailure';
export const UPDATE_VIEW_DESCRIPTION_FAILURE_VIEW_IS_A_REFERENCE =
    'europa.space.UpdateViewDescription.ViewIsAReference';
export const UPDATE_VIEW_NAME_FAILURE_ALREADY_UP_TO_DATE =
    'europa.space.UpdateViewName.AlreadyUpToDate';
export const UPDATE_VIEW_NAME_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.UpdateViewName.AmbiguousColumnReference';
export const UPDATE_VIEW_NAME_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.space.UpdateViewName.AssetModificationNotPermitted';
export const UPDATE_VIEW_NAME_FAILURE_ASSET_NAME_ALREADY_EXISTS =
    'europa.space.UpdateViewName.AssetNameAlreadyExists';
export const UPDATE_VIEW_NAME_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.UpdateViewName.CannotCastValueOfType';
export const UPDATE_VIEW_NAME_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.UpdateViewName.CircularReference';
export const UPDATE_VIEW_NAME_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.UpdateViewName.ClientConnectionError';
export const UPDATE_VIEW_NAME_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.UpdateViewName.CompilationFailedWithDatasetError';
export const UPDATE_VIEW_NAME_FAILURE_DATA_LOADING_FAILED =
    'europa.space.UpdateViewName.DataLoadingFailed';
export const UPDATE_VIEW_NAME_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateViewName.DatabaseNotExistsOrNotAuthorized';
export const UPDATE_VIEW_NAME_FAILURE_DUPLICATE_COLUMN_NAMES =
    'europa.space.UpdateViewName.DuplicateColumnNames';
export const UPDATE_VIEW_NAME_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.UpdateViewName.EntityNotFoundOrNotAccessible';
export const UPDATE_VIEW_NAME_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.UpdateViewName.InsufficientPrivileges';
export const UPDATE_VIEW_NAME_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.UpdateViewName.InsufficientTaskPrivileges';
export const UPDATE_VIEW_NAME_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.UpdateViewName.InvalidAccessToken';
export const UPDATE_VIEW_NAME_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.UpdateViewName.InvalidAccountName';
export const UPDATE_VIEW_NAME_FAILURE_INVALID_IDENTIFIER =
    'europa.space.UpdateViewName.InvalidIdentifier';
export const UPDATE_VIEW_NAME_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.UpdateViewName.InvalidParameterTypeForFunction';
export const UPDATE_VIEW_NAME_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.UpdateViewName.MaxFileSizeExceeded';
export const UPDATE_VIEW_NAME_FAILURE_MISSING_COLUMN = 'europa.space.UpdateViewName.MissingColumn';
export const UPDATE_VIEW_NAME_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.UpdateViewName.NoActiveWarehouseSelected';
export const UPDATE_VIEW_NAME_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.UpdateViewName.NotAuthenticatedToSnowflake';
export const UPDATE_VIEW_NAME_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateViewName.NotExistsOrNotAuthorized';
export const UPDATE_VIEW_NAME_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.UpdateViewName.NotExistsOrOperationCannotBePerformed';
export const UPDATE_VIEW_NAME_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.UpdateViewName.ObjectAlreadyExists';
export const UPDATE_VIEW_NAME_FAILURE_OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'europa.space.UpdateViewName.OutputColumnsWithInvisibleControlCharacters';
export const UPDATE_VIEW_NAME_FAILURE_OUTPUT_COLUMNS_WITH_LINE_SEPARATOR =
    'europa.space.UpdateViewName.OutputColumnsWithLineSeparator';
export const UPDATE_VIEW_NAME_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.UpdateViewName.SchemaNotExistsOrNotAuthorized';
export const UPDATE_VIEW_NAME_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.UpdateViewName.SnowflakeInternalServerError';
export const UPDATE_VIEW_NAME_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.UpdateViewName.SnowflakeNotConfigured';
export const UPDATE_VIEW_NAME_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.UpdateViewName.SnowflakeQueryCanceled';
export const UPDATE_VIEW_NAME_FAILURE_TIMEOUT = 'europa.space.UpdateViewName.Timeout';
export const UPDATE_VIEW_NAME_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.UpdateViewName.UncategorizedSqlError';
export const UPDATE_VIEW_NAME_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.UpdateViewName.UnexpectedFailure';
export const UPDATE_VIEW_NAME_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.UpdateViewName.UnknownFunction';
export const UPDATE_VIEW_NAME_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.UpdateViewName.UnknownFunctions';
export const UPDATE_VIEW_NAME_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.UpdateViewName.UserDiffersFromToken';
export const UPDATE_VIEW_NAME_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.UpdateViewName.ValueNotRecognized';
export const UPDATE_VIEW_NAME_FAILURE_VIEW_IS_A_REFERENCE =
    'europa.space.UpdateViewName.ViewIsAReference';
export const UPDATE_VIEW_NAME_SUCCESS_VIEW_NAME_UPDATED =
    'europa.space.UpdateViewName.ViewNameUpdated';
export const UPDATE_VIEW_NAME_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.UpdateViewName.WarehouseSuspended';
export const VALIDATE_FORMULA_COLUMN_IS_DELETABLE_FAILURE_COLUMN_DOES_NOT_EXIST =
    'europa.space.ValidateFormulaColumnIsDeletable.ColumnDoesNotExist';
export const VALIDATE_FORMULA_COLUMN_IS_DELETABLE_SUCCESS_COLUMN_IS_DELETABLE =
    'europa.space.ValidateFormulaColumnIsDeletable.ColumnIsDeletable';
export const VALIDATE_FORMULA_COLUMN_IS_DELETABLE_FAILURE_COLUMN_IS_REFERENCED =
    'europa.space.ValidateFormulaColumnIsDeletable.ColumnIsReferenced';
export const VALIDATE_FORMULA_COLUMN_IS_DELETABLE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ValidateFormulaColumnIsDeletable.UnexpectedFailure';
export const VALIDATE_NEW_FORMULA_FAILURE_CIRCULAR_REFERENCE =
    'europa.space.ValidateNewFormula.CircularReference';
export const VALIDATE_NEW_FORMULA_FAILURE_INVALID_EXPRESSION =
    'europa.space.ValidateNewFormula.InvalidExpression';
export const VALIDATE_NEW_FORMULA_FAILURE_MISSING_SOURCE_COLUMN =
    'europa.space.ValidateNewFormula.MissingSourceColumn';
export const VALIDATE_NEW_FORMULA_FAILURE_REFERENCED_COLUM_IN_ERROR =
    'europa.space.ValidateNewFormula.ReferencedColumInError';
export const VALIDATE_NEW_FORMULA_FAILURE_SELF_REFERENCE =
    'europa.space.ValidateNewFormula.SelfReference';
export const VALIDATE_NEW_FORMULA_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ValidateNewFormula.UnexpectedFailure';
export const VALIDATE_NEW_FORMULA_FAILURE_UNKNOWN_COLUMN_REFERENCE =
    'europa.space.ValidateNewFormula.UnknownColumnReference';
export const VALIDATE_NEW_FORMULA_SUCCESS_VALID_FORMULA =
    'europa.space.ValidateNewFormula.ValidFormula';
export const VALIDATE_SCHEMA_EXCHANGE_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ValidateSchemaExchange.EntityNotFoundOrNotAccessible';
export const VALIDATE_SCHEMA_EXCHANGE_SUCCESS_SCHEMA_EXCHANGEABILITY =
    'europa.space.ValidateSchemaExchange.SchemaExchangeability';
export const VALIDATE_SCHEMA_EXCHANGE_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ValidateSchemaExchange.UnexpectedFailure';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.space.ValidateSnowflakeAccess.AmbiguousColumnReference';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.space.ValidateSnowflakeAccess.CannotCastValueOfType';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.space.ValidateSnowflakeAccess.ClientConnectionError';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_COMPILATION_FAILED_WITH_DATASET_ERROR =
    'europa.space.ValidateSnowflakeAccess.CompilationFailedWithDatasetError';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_DATA_LOADING_FAILED =
    'europa.space.ValidateSnowflakeAccess.DataLoadingFailed';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ValidateSnowflakeAccess.DatabaseNotExistsOrNotAuthorized';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.space.ValidateSnowflakeAccess.EntityNotFoundOrNotAccessible';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.space.ValidateSnowflakeAccess.InsufficientPrivileges';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.space.ValidateSnowflakeAccess.InsufficientTaskPrivileges';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.space.ValidateSnowflakeAccess.InvalidAccessToken';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.space.ValidateSnowflakeAccess.InvalidAccountName';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INVALID_IDENTIFIER =
    'europa.space.ValidateSnowflakeAccess.InvalidIdentifier';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.space.ValidateSnowflakeAccess.InvalidParameterTypeForFunction';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.space.ValidateSnowflakeAccess.MaxFileSizeExceeded';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_MISSING_COLUMN =
    'europa.space.ValidateSnowflakeAccess.MissingColumn';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.space.ValidateSnowflakeAccess.NoActiveWarehouseSelected';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_NO_DEPLOYMENT_HISTORY =
    'europa.space.ValidateSnowflakeAccess.NoDeploymentHistory';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.space.ValidateSnowflakeAccess.NotAuthenticatedToSnowflake';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ValidateSnowflakeAccess.NotExistsOrNotAuthorized';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.space.ValidateSnowflakeAccess.NotExistsOrOperationCannotBePerformed';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.space.ValidateSnowflakeAccess.ObjectAlreadyExists';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.space.ValidateSnowflakeAccess.SchemaNotExistsOrNotAuthorized';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.space.ValidateSnowflakeAccess.SnowflakeInternalServerError';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.space.ValidateSnowflakeAccess.SnowflakeNotConfigured';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.space.ValidateSnowflakeAccess.SnowflakeQueryCanceled';
export const VALIDATE_SNOWFLAKE_ACCESS_SUCCESS_SNOWFLAKE_TABLE_ACCESS_VALIDATED =
    'europa.space.ValidateSnowflakeAccess.SnowflakeTableAccessValidated';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_TIMEOUT =
    'europa.space.ValidateSnowflakeAccess.Timeout';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.space.ValidateSnowflakeAccess.UncategorizedSqlError';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_UNEXPECTED_FAILURE =
    'europa.space.ValidateSnowflakeAccess.UnexpectedFailure';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_UNKNOWN_FUNCTION =
    'europa.space.ValidateSnowflakeAccess.UnknownFunction';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.space.ValidateSnowflakeAccess.UnknownFunctions';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.space.ValidateSnowflakeAccess.UserDiffersFromToken';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.space.ValidateSnowflakeAccess.ValueNotRecognized';
export const VALIDATE_SNOWFLAKE_ACCESS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.space.ValidateSnowflakeAccess.WarehouseSuspended';
